var fr = Object.defineProperty;
var dr = (e, t, r) => t in e ? fr(e, t, { enumerable: !0, configurable: !0, writable: !0, value: r }) : e[t] = r;
var h = (e, t, r) => dr(e, typeof t != "symbol" ? t + "" : t, r);
import { DEG_TO_RAD as Ss, RAD_TO_DEG as Ts, Vector2 as Ls, angleDifference as Rs, clamp as ws, lerp as Ds, lerpAngle as Ms, perlinNoise as Ps, random as Vs, randomBool as js, randomChoice as Cs, randomInt as Gs, randomSign as xs, shuffle as Is, shuffleInPlace as Bs } from "./tp-games-lib.math.es.js";
var b = /* @__PURE__ */ ((e) => (e.DEBUG = "DEBUG", e.AppData_HOSTER = "AppData_HOSTER", e.AppData_CONTROLLER = "AppData_CONTROLLER", e.INIT_GAME_HOSTER = "INIT_GAME_HOSTER", e.INIT_GAME_CONTROLLER = "INIT_GAME_CONTROLLER", e.READY_STATUS_HOSTER = "READY_STATUS_HOSTER", e.READY_STATUS_CONTROLLER = "READY_STATUS_CONTROLLER", e.PING_HOSTER = "PING_HOSTER", e.PONG_CONTROLLER = "PONG_CONTROLLER", e.PONG_HOSTER = "PONG_HOSTER", e.GAME_ACTION_HOSTER = "GAME_ACTION_HOSTER", e.GAME_ACTION_CONTROLLER = "GAME_ACTION_CONTROLLER", e.GAME_ACTION_RESPONSE_HOSTER = "GAME_ACTION_RESPONSE_HOSTER", e.GAME_ACTION_RESPONSE_CONTROLLER = "GAME_ACTION_RESPONSE_CONTROLLER", e.END_GAME_HOSTER = "END_GAME_HOSTER", e.END_GAME_CONTROLLER = "END_GAME_CONTROLLER", e.RELOAD_GAME_HOSTER = "RELOAD_GAME_HOSTER", e.RELOAD_GAME_CONTROLLER = "RELOAD_GAME_CONTROLLER", e.SET_GLOBAL_SETTING_HOSTER_G2P = "SET_GLOBAL_SETTING_HOSTER_G2P", e.SET_GLOBAL_SETTING_CONTROLLER_G2P = "SET_GLOBAL_SETTING_CONTROLLER_G2P", e.SET_GAME_STORAGE_HOSTER_G2P = "SET_GAME_STORAGE_HOSTER_G2P", e.SET_GAME_STORAGE_CONTROLLER_G2P = "SET_GAME_STORAGE_CONTROLLER_G2P", e.UPDATED_GLOBAL_SETTING_HOSTER_P2G = "UPDATED_GLOBAL_SETTING_HOSTER_P2G", e.UPDATED_GLOBAL_SETTING_CONTROLLER_P2G = "UPDATED_GLOBAL_SETTING_CONTROLLER_P2G", e.UPDATED_GAME_STORAGE_HOSTER_P2G = "UPDATED_GAME_STORAGE_HOSTER_P2G", e.UPDATED_GAME_STORAGE_CONTROLLER_P2G = "UPDATED_GAME_STORAGE_CONTROLLER_P2G", e))(b || {});
function _r(e) {
  return typeof e == "object" && e !== null && "type" in e && (typeof e.type == "number" || typeof e.type == "string") && "data" in e && typeof e.data < "u";
}
function hr(e) {
  if (window.parent)
    window.parent.postMessage(e, "*");
  else
    throw new Error("No parent window found");
}
class hn {
  constructor() {
    h(this, "connectionId", null);
    /**
     * Array of app message listeners.
     */
    h(this, "appMessageListeners", []);
    /**
     * Array of game message listeners.
     */
    h(this, "gameMessageListeners", []);
  }
  /**
   * Sends a message to the host or the controller.
   * @param message - The message to be sent.
   */
  sendMessage(t) {
    hr(t);
  }
  /**
   * Sends an app message to the host or the controller.
   * @param message - The app message to be sent.
   */
  sendAppMessage(t) {
    this.sendMessage(t);
  }
  /**
   * Handles the incoming message and notifies the app message listeners.
   * @param message - The incoming message.
   * @throws Error if the message is not a valid data transfer.
   */
  messageHandler(t) {
    if (!_r(t))
      throw new Error("Invalid data transfer");
    this.appMessageListeners.filter(({ type: r }) => r === null || r === t.type).forEach((r) => r.listener(t));
  }
  /**
   * Adds an app message listener.
   * @param listener - The listener function to be added.
   * @param type - The specific message type to listen for. If not provided, listens for all message types.
   * @returns An object with a `destroy` method to remove the listener.
   */
  addAppMessageListener(t, r = null) {
    const n = { listener: t, type: r };
    return this.appMessageListeners.push(n), {
      destroy: () => {
        const i = this.appMessageListeners.indexOf(n);
        i !== -1 && this.appMessageListeners.splice(i, 1);
      }
    };
  }
  /**
   * Adds a game message listener.
   * @param listener - The listener function to be added.
   * @returns An object with a `destroy` method to remove the listener.
   */
  addBaseGameMessageListener(t) {
    const r = { listener: t };
    return this.gameMessageListeners.push(r), {
      destroy: () => {
        const n = this.gameMessageListeners.indexOf(r);
        n !== -1 && this.gameMessageListeners.splice(n, 1);
      }
    };
  }
}
var pr = {
  0: "Invalid value for configuration 'enforceActions', expected 'never', 'always' or 'observed'",
  1: function(t, r) {
    return "Cannot apply '" + t + "' to '" + r.toString() + "': Field not found.";
  },
  /*
  2(prop) {
      return `invalid decorator for '${prop.toString()}'`
  },
  3(prop) {
      return `Cannot decorate '${prop.toString()}': action can only be used on properties with a function value.`
  },
  4(prop) {
      return `Cannot decorate '${prop.toString()}': computed can only be used on getter properties.`
  },
  */
  5: "'keys()' can only be used on observable objects, arrays, sets and maps",
  6: "'values()' can only be used on observable objects, arrays, sets and maps",
  7: "'entries()' can only be used on observable objects, arrays and maps",
  8: "'set()' can only be used on observable objects, arrays and maps",
  9: "'remove()' can only be used on observable objects, arrays and maps",
  10: "'has()' can only be used on observable objects, arrays and maps",
  11: "'get()' can only be used on observable objects, arrays and maps",
  12: "Invalid annotation",
  13: "Dynamic observable objects cannot be frozen. If you're passing observables to 3rd party component/function that calls Object.freeze, pass copy instead: toJS(observable)",
  14: "Intercept handlers should return nothing or a change object",
  15: "Observable arrays cannot be frozen. If you're passing observables to 3rd party component/function that calls Object.freeze, pass copy instead: toJS(observable)",
  16: "Modification exception: the internal structure of an observable array was changed.",
  17: function(t, r) {
    return "[mobx.array] Index out of bounds, " + t + " is larger than " + r;
  },
  18: "mobx.map requires Map polyfill for the current browser. Check babel-polyfill or core-js/es6/map.js",
  19: function(t) {
    return "Cannot initialize from classes that inherit from Map: " + t.constructor.name;
  },
  20: function(t) {
    return "Cannot initialize map from " + t;
  },
  21: function(t) {
    return "Cannot convert to map from '" + t + "'";
  },
  22: "mobx.set requires Set polyfill for the current browser. Check babel-polyfill or core-js/es6/set.js",
  23: "It is not possible to get index atoms from arrays",
  24: function(t) {
    return "Cannot obtain administration from " + t;
  },
  25: function(t, r) {
    return "the entry '" + t + "' does not exist in the observable map '" + r + "'";
  },
  26: "please specify a property",
  27: function(t, r) {
    return "no observable property '" + t.toString() + "' found on the observable object '" + r + "'";
  },
  28: function(t) {
    return "Cannot obtain atom from " + t;
  },
  29: "Expecting some object",
  30: "invalid action stack. did you forget to finish an action?",
  31: "missing option for computed: get",
  32: function(t, r) {
    return "Cycle detected in computation " + t + ": " + r;
  },
  33: function(t) {
    return "The setter of computed value '" + t + "' is trying to update itself. Did you intend to update an _observable_ value, instead of the computed property?";
  },
  34: function(t) {
    return "[ComputedValue '" + t + "'] It is not possible to assign a new value to a computed value.";
  },
  35: "There are multiple, different versions of MobX active. Make sure MobX is loaded only once or use `configure({ isolateGlobalState: true })`",
  36: "isolateGlobalState should be called before MobX is running any reactions",
  37: function(t) {
    return "[mobx] `observableArray." + t + "()` mutates the array in-place, which is not allowed inside a derivation. Use `array.slice()." + t + "()` instead";
  },
  38: "'ownKeys()' can only be used on observable objects",
  39: "'defineProperty()' can only be used on observable objects"
}, vr = process.env.NODE_ENV !== "production" ? pr : {};
function d(e) {
  for (var t = arguments.length, r = new Array(t > 1 ? t - 1 : 0), n = 1; n < t; n++)
    r[n - 1] = arguments[n];
  if (process.env.NODE_ENV !== "production") {
    var i = typeof e == "string" ? e : vr[e];
    throw typeof i == "function" && (i = i.apply(null, r)), new Error("[MobX] " + i);
  }
  throw new Error(typeof e == "number" ? "[MobX] minified error nr: " + e + (r.length ? " " + r.map(String).join(",") : "") + ". Find the full error at: https://github.com/mobxjs/mobx/blob/main/packages/mobx/src/errors.ts" : "[MobX] " + e);
}
var br = {};
function Mt() {
  return typeof globalThis < "u" ? globalThis : typeof window < "u" ? window : typeof global < "u" ? global : typeof self < "u" ? self : br;
}
var pn = Object.assign, Xe = Object.getOwnPropertyDescriptor, Y = Object.defineProperty, it = Object.prototype, Ye = [];
Object.freeze(Ye);
var Pt = {};
Object.freeze(Pt);
var gr = typeof Proxy < "u", Or = /* @__PURE__ */ Object.toString();
function vn() {
  gr || d(process.env.NODE_ENV !== "production" ? "`Proxy` objects are not available in the current environment. Please configure MobX to enable a fallback implementation.`" : "Proxy not available");
}
function je(e) {
  process.env.NODE_ENV !== "production" && l.verifyProxies && d("MobX is currently configured to be able to run in ES5 mode, but in ES5 MobX won't be able to " + e);
}
function V() {
  return ++l.mobxGuid;
}
function Vt(e) {
  var t = !1;
  return function() {
    if (!t)
      return t = !0, e.apply(this, arguments);
  };
}
var ye = function() {
};
function m(e) {
  return typeof e == "function";
}
function he(e) {
  var t = typeof e;
  switch (t) {
    case "string":
    case "symbol":
    case "number":
      return !0;
  }
  return !1;
}
function st(e) {
  return e !== null && typeof e == "object";
}
function S(e) {
  if (!st(e))
    return !1;
  var t = Object.getPrototypeOf(e);
  if (t == null)
    return !0;
  var r = Object.hasOwnProperty.call(t, "constructor") && t.constructor;
  return typeof r == "function" && r.toString() === Or;
}
function bn(e) {
  var t = e == null ? void 0 : e.constructor;
  return t ? t.name === "GeneratorFunction" || t.displayName === "GeneratorFunction" : !1;
}
function Ie(e, t, r) {
  Y(e, t, {
    enumerable: !1,
    writable: !0,
    configurable: !0,
    value: r
  });
}
function gn(e, t, r) {
  Y(e, t, {
    enumerable: !1,
    writable: !1,
    configurable: !0,
    value: r
  });
}
function be(e, t) {
  var r = "isMobX" + e;
  return t.prototype[r] = !0, function(n) {
    return st(n) && n[r] === !0;
  };
}
function Me(e) {
  return e != null && Object.prototype.toString.call(e) === "[object Map]";
}
function mr(e) {
  var t = Object.getPrototypeOf(e), r = Object.getPrototypeOf(t), n = Object.getPrototypeOf(r);
  return n === null;
}
function Q(e) {
  return e != null && Object.prototype.toString.call(e) === "[object Set]";
}
var On = typeof Object.getOwnPropertySymbols < "u";
function Er(e) {
  var t = Object.keys(e);
  if (!On)
    return t;
  var r = Object.getOwnPropertySymbols(e);
  return r.length ? [].concat(t, r.filter(function(n) {
    return it.propertyIsEnumerable.call(e, n);
  })) : t;
}
var Se = typeof Reflect < "u" && Reflect.ownKeys ? Reflect.ownKeys : On ? function(e) {
  return Object.getOwnPropertyNames(e).concat(Object.getOwnPropertySymbols(e));
} : (
  /* istanbul ignore next */
  Object.getOwnPropertyNames
);
function gt(e) {
  return typeof e == "string" ? e : typeof e == "symbol" ? e.toString() : new String(e).toString();
}
function mn(e) {
  return e === null ? null : typeof e == "object" ? "" + e : e;
}
function U(e, t) {
  return it.hasOwnProperty.call(e, t);
}
var yr = Object.getOwnPropertyDescriptors || function(t) {
  var r = {};
  return Se(t).forEach(function(n) {
    r[n] = Xe(t, n);
  }), r;
};
function w(e, t) {
  return !!(e & t);
}
function D(e, t, r) {
  return r ? e |= t : e &= ~t, e;
}
function Kt(e, t) {
  (t == null || t > e.length) && (t = e.length);
  for (var r = 0, n = Array(t); r < t; r++) n[r] = e[r];
  return n;
}
function Ar(e, t) {
  for (var r = 0; r < t.length; r++) {
    var n = t[r];
    n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, Sr(n.key), n);
  }
}
function Pe(e, t, r) {
  return t && Ar(e.prototype, t), Object.defineProperty(e, "prototype", {
    writable: !1
  }), e;
}
function Ae(e, t) {
  var r = typeof Symbol < "u" && e[Symbol.iterator] || e["@@iterator"];
  if (r) return (r = r.call(e)).next.bind(r);
  if (Array.isArray(e) || (r = Tr(e)) || t) {
    r && (e = r);
    var n = 0;
    return function() {
      return n >= e.length ? {
        done: !0
      } : {
        done: !1,
        value: e[n++]
      };
    };
  }
  throw new TypeError(`Invalid attempt to iterate non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function Z() {
  return Z = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) ({}).hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, Z.apply(null, arguments);
}
function En(e, t) {
  e.prototype = Object.create(t.prototype), e.prototype.constructor = e, Ot(e, t);
}
function Ot(e, t) {
  return Ot = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(r, n) {
    return r.__proto__ = n, r;
  }, Ot(e, t);
}
function Nr(e, t) {
  if (typeof e != "object" || !e) return e;
  var r = e[Symbol.toPrimitive];
  if (r !== void 0) {
    var n = r.call(e, t);
    if (typeof n != "object") return n;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return String(e);
}
function Sr(e) {
  var t = Nr(e, "string");
  return typeof t == "symbol" ? t : t + "";
}
function Tr(e, t) {
  if (e) {
    if (typeof e == "string") return Kt(e, t);
    var r = {}.toString.call(e).slice(8, -1);
    return r === "Object" && e.constructor && (r = e.constructor.name), r === "Map" || r === "Set" ? Array.from(e) : r === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r) ? Kt(e, t) : void 0;
  }
}
var N = /* @__PURE__ */ Symbol("mobx-stored-annotations");
function J(e) {
  function t(r, n) {
    if (Ue(n))
      return e.decorate_20223_(r, n);
    Be(r, n, e);
  }
  return Object.assign(t, e);
}
function Be(e, t, r) {
  if (U(e, N) || Ie(e, N, Z({}, e[N])), process.env.NODE_ENV !== "production" && Je(r) && !U(e[N], t)) {
    var n = e.constructor.name + ".prototype." + t.toString();
    d("'" + n + "' is decorated with 'override', but no such decorated member was found on prototype.");
  }
  Lr(e, r, t), Je(r) || (e[N][t] = r);
}
function Lr(e, t, r) {
  if (process.env.NODE_ENV !== "production" && !Je(t) && U(e[N], r)) {
    var n = e.constructor.name + ".prototype." + r.toString(), i = e[N][r].annotationType_, s = t.annotationType_;
    d("Cannot apply '@" + s + "' to '" + n + "':" + (`
The field is already decorated with '@` + i + "'.") + `
Re-decorating fields is not allowed.
Use '@override' decorator for methods overridden by subclass.`);
  }
}
function Rr(e) {
  return U(e, N) || Ie(e, N, Z({}, e[N])), e[N];
}
function Ue(e) {
  return typeof e == "object" && typeof e.kind == "string";
}
function ot(e, t) {
  process.env.NODE_ENV !== "production" && !t.includes(e.kind) && d("The decorator applied to '" + String(e.name) + "' cannot be used on a " + e.kind + " element");
}
var _ = /* @__PURE__ */ Symbol("mobx administration"), ae = /* @__PURE__ */ function() {
  function e(r) {
    r === void 0 && (r = process.env.NODE_ENV !== "production" ? "Atom@" + V() : "Atom"), this.name_ = void 0, this.flags_ = 0, this.observers_ = /* @__PURE__ */ new Set(), this.lastAccessedBy_ = 0, this.lowestObserverState_ = g.NOT_TRACKING_, this.onBOL = void 0, this.onBUOL = void 0, this.name_ = r;
  }
  var t = e.prototype;
  return t.onBO = function() {
    this.onBOL && this.onBOL.forEach(function(n) {
      return n();
    });
  }, t.onBUO = function() {
    this.onBUOL && this.onBUOL.forEach(function(n) {
      return n();
    });
  }, t.reportObserved = function() {
    return In(this);
  }, t.reportChanged = function() {
    I(), Bn(this), B();
  }, t.toString = function() {
    return this.name_;
  }, Pe(e, [{
    key: "isBeingObserved",
    get: function() {
      return w(this.flags_, e.isBeingObservedMask_);
    },
    set: function(n) {
      this.flags_ = D(this.flags_, e.isBeingObservedMask_, n);
    }
  }, {
    key: "isPendingUnobservation",
    get: function() {
      return w(this.flags_, e.isPendingUnobservationMask_);
    },
    set: function(n) {
      this.flags_ = D(this.flags_, e.isPendingUnobservationMask_, n);
    }
  }, {
    key: "diffValue",
    get: function() {
      return w(this.flags_, e.diffValueMask_) ? 1 : 0;
    },
    set: function(n) {
      this.flags_ = D(this.flags_, e.diffValueMask_, n === 1);
    }
  }]);
}();
ae.isBeingObservedMask_ = 1;
ae.isPendingUnobservationMask_ = 2;
ae.diffValueMask_ = 4;
var jt = /* @__PURE__ */ be("Atom", ae);
function yn(e, t, r) {
  t === void 0 && (t = ye), r === void 0 && (r = ye);
  var n = new ae(e);
  return t !== ye && Ii(n, t), r !== ye && Xn(n, r), n;
}
function wr(e, t) {
  return e === t;
}
function Dr(e, t) {
  return Ut(e, t);
}
function Mr(e, t) {
  return Ut(e, t, 1);
}
function Pr(e, t) {
  return Object.is ? Object.is(e, t) : e === t ? e !== 0 || 1 / e === 1 / t : e !== e && t !== t;
}
var Te = {
  identity: wr,
  structural: Dr,
  default: Pr,
  shallow: Mr
};
function pe(e, t, r) {
  return we(e) ? e : Array.isArray(e) ? E.array(e, {
    name: r
  }) : S(e) ? E.object(e, void 0, {
    name: r
  }) : Me(e) ? E.map(e, {
    name: r
  }) : Q(e) ? E.set(e, {
    name: r
  }) : typeof e == "function" && !Le(e) && !xe(e) ? bn(e) ? Re(e) : Ge(r, e) : e;
}
function Vr(e, t, r) {
  if (e == null || me(e) || Fe(e) || ue(e) || W(e))
    return e;
  if (Array.isArray(e))
    return E.array(e, {
      name: r,
      deep: !1
    });
  if (S(e))
    return E.object(e, void 0, {
      name: r,
      deep: !1
    });
  if (Me(e))
    return E.map(e, {
      name: r,
      deep: !1
    });
  if (Q(e))
    return E.set(e, {
      name: r,
      deep: !1
    });
  process.env.NODE_ENV !== "production" && d("The shallow modifier / decorator can only used in combination with arrays, objects, maps and sets");
}
function at(e) {
  return e;
}
function jr(e, t) {
  return process.env.NODE_ENV !== "production" && we(e) && d("observable.struct should not be used with observable values"), Ut(e, t) ? t : e;
}
var Cr = "override";
function Je(e) {
  return e.annotationType_ === Cr;
}
function He(e, t) {
  return {
    annotationType_: e,
    options_: t,
    make_: Gr,
    extend_: xr,
    decorate_20223_: Ir
  };
}
function Gr(e, t, r, n) {
  var i;
  if ((i = this.options_) != null && i.bound)
    return this.extend_(e, t, r, !1) === null ? 0 : 1;
  if (n === e.target_)
    return this.extend_(e, t, r, !1) === null ? 0 : 2;
  if (Le(r.value))
    return 1;
  var s = An(e, this, t, r, !1);
  return Y(n, t, s), 2;
}
function xr(e, t, r, n) {
  var i = An(e, this, t, r);
  return e.defineProperty_(t, i, n);
}
function Ir(e, t) {
  process.env.NODE_ENV !== "production" && ot(t, ["method", "field"]);
  var r = t.kind, n = t.name, i = t.addInitializer, s = this, o = function(c) {
    var f, p, v, C;
    return oe((f = (p = s.options_) == null ? void 0 : p.name) != null ? f : n.toString(), c, (v = (C = s.options_) == null ? void 0 : C.autoAction) != null ? v : !1);
  };
  if (r == "field")
    return function(u) {
      var c, f = u;
      return Le(f) || (f = o(f)), (c = s.options_) != null && c.bound && (f = f.bind(this), f.isMobxAction = !0), f;
    };
  if (r == "method") {
    var a;
    return Le(e) || (e = o(e)), (a = this.options_) != null && a.bound && i(function() {
      var u = this, c = u[n].bind(u);
      c.isMobxAction = !0, u[n] = c;
    }), e;
  }
  d("Cannot apply '" + s.annotationType_ + "' to '" + String(n) + "' (kind: " + r + "):" + (`
'` + s.annotationType_ + "' can only be used on properties with a function value."));
}
function Br(e, t, r, n) {
  var i = t.annotationType_, s = n.value;
  process.env.NODE_ENV !== "production" && !m(s) && d("Cannot apply '" + i + "' to '" + e.name_ + "." + r.toString() + "':" + (`
'` + i + "' can only be used on properties with a function value."));
}
function An(e, t, r, n, i) {
  var s, o, a, u, c, f, p;
  i === void 0 && (i = l.safeDescriptors), Br(e, t, r, n);
  var v = n.value;
  if ((s = t.options_) != null && s.bound) {
    var C;
    v = v.bind((C = e.proxy_) != null ? C : e.target_);
  }
  return {
    value: oe(
      (o = (a = t.options_) == null ? void 0 : a.name) != null ? o : r.toString(),
      v,
      (u = (c = t.options_) == null ? void 0 : c.autoAction) != null ? u : !1,
      // https://github.com/mobxjs/mobx/discussions/3140
      (f = t.options_) != null && f.bound ? (p = e.proxy_) != null ? p : e.target_ : void 0
    ),
    // Non-configurable for classes
    // prevents accidental field redefinition in subclass
    configurable: i ? e.isPlainObject_ : !0,
    // https://github.com/mobxjs/mobx/pull/2641#issuecomment-737292058
    enumerable: !1,
    // Non-obsevable, therefore non-writable
    // Also prevents rewriting in subclass constructor
    writable: !i
  };
}
function Nn(e, t) {
  return {
    annotationType_: e,
    options_: t,
    make_: Ur,
    extend_: Hr,
    decorate_20223_: kr
  };
}
function Ur(e, t, r, n) {
  var i;
  if (n === e.target_)
    return this.extend_(e, t, r, !1) === null ? 0 : 2;
  if ((i = this.options_) != null && i.bound && (!U(e.target_, t) || !xe(e.target_[t])) && this.extend_(e, t, r, !1) === null)
    return 0;
  if (xe(r.value))
    return 1;
  var s = Sn(e, this, t, r, !1, !1);
  return Y(n, t, s), 2;
}
function Hr(e, t, r, n) {
  var i, s = Sn(e, this, t, r, (i = this.options_) == null ? void 0 : i.bound);
  return e.defineProperty_(t, s, n);
}
function kr(e, t) {
  var r;
  process.env.NODE_ENV !== "production" && ot(t, ["method"]);
  var n = t.name, i = t.addInitializer;
  return xe(e) || (e = Re(e)), (r = this.options_) != null && r.bound && i(function() {
    var s = this, o = s[n].bind(s);
    o.isMobXFlow = !0, s[n] = o;
  }), e;
}
function $r(e, t, r, n) {
  var i = t.annotationType_, s = n.value;
  process.env.NODE_ENV !== "production" && !m(s) && d("Cannot apply '" + i + "' to '" + e.name_ + "." + r.toString() + "':" + (`
'` + i + "' can only be used on properties with a generator function value."));
}
function Sn(e, t, r, n, i, s) {
  s === void 0 && (s = l.safeDescriptors), $r(e, t, r, n);
  var o = n.value;
  if (xe(o) || (o = Re(o)), i) {
    var a;
    o = o.bind((a = e.proxy_) != null ? a : e.target_), o.isMobXFlow = !0;
  }
  return {
    value: o,
    // Non-configurable for classes
    // prevents accidental field redefinition in subclass
    configurable: s ? e.isPlainObject_ : !0,
    // https://github.com/mobxjs/mobx/pull/2641#issuecomment-737292058
    enumerable: !1,
    // Non-obsevable, therefore non-writable
    // Also prevents rewriting in subclass constructor
    writable: !s
  };
}
function Ct(e, t) {
  return {
    annotationType_: e,
    options_: t,
    make_: Kr,
    extend_: Fr,
    decorate_20223_: qr
  };
}
function Kr(e, t, r) {
  return this.extend_(e, t, r, !1) === null ? 0 : 1;
}
function Fr(e, t, r, n) {
  return zr(e, this, t, r), e.defineComputedProperty_(t, Z({}, this.options_, {
    get: r.get,
    set: r.set
  }), n);
}
function qr(e, t) {
  process.env.NODE_ENV !== "production" && ot(t, ["getter"]);
  var r = this, n = t.name, i = t.addInitializer;
  return i(function() {
    var s = Oe(this)[_], o = Z({}, r.options_, {
      get: e,
      context: this
    });
    o.name || (o.name = process.env.NODE_ENV !== "production" ? s.name_ + "." + n.toString() : "ObservableObject." + n.toString()), s.values_.set(n, new k(o));
  }), function() {
    return this[_].getObservablePropValue_(n);
  };
}
function zr(e, t, r, n) {
  var i = t.annotationType_, s = n.get;
  process.env.NODE_ENV !== "production" && !s && d("Cannot apply '" + i + "' to '" + e.name_ + "." + r.toString() + "':" + (`
'` + i + "' can only be used on getter(+setter) properties."));
}
function ut(e, t) {
  return {
    annotationType_: e,
    options_: t,
    make_: Wr,
    extend_: Xr,
    decorate_20223_: Yr
  };
}
function Wr(e, t, r) {
  return this.extend_(e, t, r, !1) === null ? 0 : 1;
}
function Xr(e, t, r, n) {
  var i, s;
  return Jr(e, this, t, r), e.defineObservableProperty_(t, r.value, (i = (s = this.options_) == null ? void 0 : s.enhancer) != null ? i : pe, n);
}
function Yr(e, t) {
  if (process.env.NODE_ENV !== "production") {
    if (t.kind === "field")
      throw d("Please use `@observable accessor " + String(t.name) + "` instead of `@observable " + String(t.name) + "`");
    ot(t, ["accessor"]);
  }
  var r = this, n = t.kind, i = t.name, s = /* @__PURE__ */ new WeakSet();
  function o(a, u) {
    var c, f, p = Oe(a)[_], v = new _e(u, (c = (f = r.options_) == null ? void 0 : f.enhancer) != null ? c : pe, process.env.NODE_ENV !== "production" ? p.name_ + "." + i.toString() : "ObservableObject." + i.toString(), !1);
    p.values_.set(i, v), s.add(a);
  }
  if (n == "accessor")
    return {
      get: function() {
        return s.has(this) || o(this, e.get.call(this)), this[_].getObservablePropValue_(i);
      },
      set: function(u) {
        return s.has(this) || o(this, u), this[_].setObservablePropValue_(i, u);
      },
      init: function(u) {
        return s.has(this) || o(this, u), u;
      }
    };
}
function Jr(e, t, r, n) {
  var i = t.annotationType_;
  process.env.NODE_ENV !== "production" && !("value" in n) && d("Cannot apply '" + i + "' to '" + e.name_ + "." + r.toString() + "':" + (`
'` + i + "' cannot be used on getter/setter properties"));
}
var Zr = "true", Qr = /* @__PURE__ */ Tn();
function Tn(e) {
  return {
    annotationType_: Zr,
    options_: e,
    make_: ei,
    extend_: ti,
    decorate_20223_: ni
  };
}
function ei(e, t, r, n) {
  var i, s;
  if (r.get)
    return ct.make_(e, t, r, n);
  if (r.set) {
    var o = oe(t.toString(), r.set);
    return n === e.target_ ? e.defineProperty_(t, {
      configurable: l.safeDescriptors ? e.isPlainObject_ : !0,
      set: o
    }) === null ? 0 : 2 : (Y(n, t, {
      configurable: !0,
      set: o
    }), 2);
  }
  if (n !== e.target_ && typeof r.value == "function") {
    var a;
    if (bn(r.value)) {
      var u, c = (u = this.options_) != null && u.autoBind ? Re.bound : Re;
      return c.make_(e, t, r, n);
    }
    var f = (a = this.options_) != null && a.autoBind ? Ge.bound : Ge;
    return f.make_(e, t, r, n);
  }
  var p = ((i = this.options_) == null ? void 0 : i.deep) === !1 ? E.ref : E;
  if (typeof r.value == "function" && (s = this.options_) != null && s.autoBind) {
    var v;
    r.value = r.value.bind((v = e.proxy_) != null ? v : e.target_);
  }
  return p.make_(e, t, r, n);
}
function ti(e, t, r, n) {
  var i, s;
  if (r.get)
    return ct.extend_(e, t, r, n);
  if (r.set)
    return e.defineProperty_(t, {
      configurable: l.safeDescriptors ? e.isPlainObject_ : !0,
      set: oe(t.toString(), r.set)
    }, n);
  if (typeof r.value == "function" && (i = this.options_) != null && i.autoBind) {
    var o;
    r.value = r.value.bind((o = e.proxy_) != null ? o : e.target_);
  }
  var a = ((s = this.options_) == null ? void 0 : s.deep) === !1 ? E.ref : E;
  return a.extend_(e, t, r, n);
}
function ni(e, t) {
  d("'" + this.annotationType_ + "' cannot be used as a decorator");
}
var ri = "observable", ii = "observable.ref", si = "observable.shallow", oi = "observable.struct", Ln = {
  deep: !0,
  name: void 0,
  defaultDecorator: void 0,
  proxy: !0
};
Object.freeze(Ln);
function qe(e) {
  return e || Ln;
}
var mt = /* @__PURE__ */ ut(ri), ai = /* @__PURE__ */ ut(ii, {
  enhancer: at
}), ui = /* @__PURE__ */ ut(si, {
  enhancer: Vr
}), ci = /* @__PURE__ */ ut(oi, {
  enhancer: jr
}), Rn = /* @__PURE__ */ J(mt);
function ze(e) {
  return e.deep === !0 ? pe : e.deep === !1 ? at : fi(e.defaultDecorator);
}
function li(e) {
  var t;
  return e ? (t = e.defaultDecorator) != null ? t : Tn(e) : void 0;
}
function fi(e) {
  var t, r;
  return e && (t = (r = e.options_) == null ? void 0 : r.enhancer) != null ? t : pe;
}
function wn(e, t, r) {
  if (Ue(t))
    return mt.decorate_20223_(e, t);
  if (he(t)) {
    Be(e, t, mt);
    return;
  }
  return we(e) ? e : S(e) ? E.object(e, t, r) : Array.isArray(e) ? E.array(e, t) : Me(e) ? E.map(e, t) : Q(e) ? E.set(e, t) : typeof e == "object" && e !== null ? e : E.box(e, t);
}
pn(wn, Rn);
var di = {
  box: function(t, r) {
    var n = qe(r);
    return new _e(t, ze(n), n.name, !0, n.equals);
  },
  array: function(t, r) {
    var n = qe(r);
    return (l.useProxies === !1 || n.proxy === !1 ? cs : Qi)(t, ze(n), n.name);
  },
  map: function(t, r) {
    var n = qe(r);
    return new nr(t, ze(n), n.name);
  },
  set: function(t, r) {
    var n = qe(r);
    return new rr(t, ze(n), n.name);
  },
  object: function(t, r, n) {
    return ce(function() {
      return Jn(l.useProxies === !1 || (n == null ? void 0 : n.proxy) === !1 ? Oe({}, n) : Xi({}, n), t, r);
    });
  },
  ref: /* @__PURE__ */ J(ai),
  shallow: /* @__PURE__ */ J(ui),
  deep: Rn,
  struct: /* @__PURE__ */ J(ci)
}, E = /* @__PURE__ */ pn(wn, di), Dn = "computed", _i = "computed.struct", Et = /* @__PURE__ */ Ct(Dn), hi = /* @__PURE__ */ Ct(_i, {
  equals: Te.structural
}), ct = function(t, r) {
  if (Ue(r))
    return Et.decorate_20223_(t, r);
  if (he(r))
    return Be(t, r, Et);
  if (S(t))
    return J(Ct(Dn, t));
  process.env.NODE_ENV !== "production" && (m(t) || d("First argument to `computed` should be an expression."), m(r) && d("A setter as second argument is no longer supported, use `{ set: fn }` option instead"));
  var n = S(r) ? r : {};
  return n.get = t, n.name || (n.name = t.name || ""), new k(n);
};
Object.assign(ct, Et);
ct.struct = /* @__PURE__ */ J(hi);
var Ft, qt, Ze = 0, pi = 1, vi = (Ft = (qt = /* @__PURE__ */ Xe(function() {
}, "name")) == null ? void 0 : qt.configurable) != null ? Ft : !1, zt = {
  value: "action",
  configurable: !0,
  writable: !1,
  enumerable: !1
};
function oe(e, t, r, n) {
  r === void 0 && (r = !1), process.env.NODE_ENV !== "production" && (m(t) || d("`action` can only be invoked on functions"), (typeof e != "string" || !e) && d("actions should have valid names, got: '" + e + "'"));
  function i() {
    return Mn(e, r, t, n || this, arguments);
  }
  return i.isMobxAction = !0, i.toString = function() {
    return t.toString();
  }, vi && (zt.value = e, Y(i, "name", zt)), i;
}
function Mn(e, t, r, n, i) {
  var s = bi(e, t, n, i);
  try {
    return r.apply(n, i);
  } catch (o) {
    throw s.error_ = o, o;
  } finally {
    gi(s);
  }
}
function bi(e, t, r, n) {
  var i = process.env.NODE_ENV !== "production" && y() && !!e, s = 0;
  if (process.env.NODE_ENV !== "production" && i) {
    s = Date.now();
    var o = n ? Array.from(n) : Ye;
    M({
      type: xt,
      name: e,
      object: r,
      arguments: o
    });
  }
  var a = l.trackingDerivation, u = !t || !a;
  I();
  var c = l.allowStateChanges;
  u && (ge(), c = lt(!0));
  var f = Gt(!0), p = {
    runAsAction_: u,
    prevDerivation_: a,
    prevAllowStateChanges_: c,
    prevAllowStateReads_: f,
    notifySpy_: i,
    startTime_: s,
    actionId_: pi++,
    parentActionId_: Ze
  };
  return Ze = p.actionId_, p;
}
function gi(e) {
  Ze !== e.actionId_ && d(30), Ze = e.parentActionId_, e.error_ !== void 0 && (l.suppressReactionErrors = !0), ft(e.prevAllowStateChanges_), Ce(e.prevAllowStateReads_), B(), e.runAsAction_ && te(e.prevDerivation_), process.env.NODE_ENV !== "production" && e.notifySpy_ && P({
    time: Date.now() - e.startTime_
  }), l.suppressReactionErrors = !1;
}
function Pn(e, t) {
  var r = lt(e);
  try {
    return t();
  } finally {
    ft(r);
  }
}
function lt(e) {
  var t = l.allowStateChanges;
  return l.allowStateChanges = e, t;
}
function ft(e) {
  l.allowStateChanges = e;
}
var Oi = "create", _e = /* @__PURE__ */ function(e) {
  function t(n, i, s, o, a) {
    var u;
    return s === void 0 && (s = process.env.NODE_ENV !== "production" ? "ObservableValue@" + V() : "ObservableValue"), o === void 0 && (o = !0), a === void 0 && (a = Te.default), u = e.call(this, s) || this, u.enhancer = void 0, u.name_ = void 0, u.equals = void 0, u.hasUnreportedChange_ = !1, u.interceptors_ = void 0, u.changeListeners_ = void 0, u.value_ = void 0, u.dehancer = void 0, u.enhancer = i, u.name_ = s, u.equals = a, u.value_ = i(n, void 0, s), process.env.NODE_ENV !== "production" && o && y() && ve({
      type: Oi,
      object: u,
      observableKind: "value",
      debugObjectName: u.name_,
      newValue: "" + u.value_
    }), u;
  }
  En(t, e);
  var r = t.prototype;
  return r.dehanceValue = function(i) {
    return this.dehancer !== void 0 ? this.dehancer(i) : i;
  }, r.set = function(i) {
    var s = this.value_;
    if (i = this.prepareNewValue_(i), i !== l.UNCHANGED) {
      var o = y();
      process.env.NODE_ENV !== "production" && o && M({
        type: $,
        object: this,
        observableKind: "value",
        debugObjectName: this.name_,
        newValue: i,
        oldValue: s
      }), this.setNewValue_(i), process.env.NODE_ENV !== "production" && o && P();
    }
  }, r.prepareNewValue_ = function(i) {
    if (X(this), G(this)) {
      var s = x(this, {
        object: this,
        type: $,
        newValue: i
      });
      if (!s)
        return l.UNCHANGED;
      i = s.newValue;
    }
    return i = this.enhancer(i, this.value_, this.name_), this.equals(this.value_, i) ? l.UNCHANGED : i;
  }, r.setNewValue_ = function(i) {
    var s = this.value_;
    this.value_ = i, this.reportChanged(), K(this) && F(this, {
      type: $,
      object: this,
      newValue: i,
      oldValue: s
    });
  }, r.get = function() {
    return this.reportObserved(), this.dehanceValue(this.value_);
  }, r.intercept_ = function(i) {
    return ke(this, i);
  }, r.observe_ = function(i, s) {
    return s && i({
      observableKind: "value",
      debugObjectName: this.name_,
      object: this,
      type: $,
      newValue: this.value_,
      oldValue: void 0
    }), $e(this, i);
  }, r.raw = function() {
    return this.value_;
  }, r.toJSON = function() {
    return this.get();
  }, r.toString = function() {
    return this.name_ + "[" + this.value_ + "]";
  }, r.valueOf = function() {
    return mn(this.get());
  }, r[Symbol.toPrimitive] = function() {
    return this.valueOf();
  }, t;
}(ae), k = /* @__PURE__ */ function() {
  function e(r) {
    this.dependenciesState_ = g.NOT_TRACKING_, this.observing_ = [], this.newObserving_ = null, this.observers_ = /* @__PURE__ */ new Set(), this.runId_ = 0, this.lastAccessedBy_ = 0, this.lowestObserverState_ = g.UP_TO_DATE_, this.unboundDepsCount_ = 0, this.value_ = new Qe(null), this.name_ = void 0, this.triggeredBy_ = void 0, this.flags_ = 0, this.derivation = void 0, this.setter_ = void 0, this.isTracing_ = H.NONE, this.scope_ = void 0, this.equals_ = void 0, this.requiresReaction_ = void 0, this.keepAlive_ = void 0, this.onBOL = void 0, this.onBUOL = void 0, r.get || d(31), this.derivation = r.get, this.name_ = r.name || (process.env.NODE_ENV !== "production" ? "ComputedValue@" + V() : "ComputedValue"), r.set && (this.setter_ = oe(process.env.NODE_ENV !== "production" ? this.name_ + "-setter" : "ComputedValue-setter", r.set)), this.equals_ = r.equals || (r.compareStructural || r.struct ? Te.structural : Te.default), this.scope_ = r.context, this.requiresReaction_ = r.requiresReaction, this.keepAlive_ = !!r.keepAlive;
  }
  var t = e.prototype;
  return t.onBecomeStale_ = function() {
    Si(this);
  }, t.onBO = function() {
    this.onBOL && this.onBOL.forEach(function(n) {
      return n();
    });
  }, t.onBUO = function() {
    this.onBUOL && this.onBUOL.forEach(function(n) {
      return n();
    });
  }, t.get = function() {
    if (this.isComputing && d(32, this.name_, this.derivation), l.inBatch === 0 && // !globalState.trackingDerivatpion &&
    this.observers_.size === 0 && !this.keepAlive_)
      yt(this) && (this.warnAboutUntrackedRead_(), I(), this.value_ = this.computeValue_(!1), B());
    else if (In(this), yt(this)) {
      var n = l.trackingContext;
      this.keepAlive_ && !n && (l.trackingContext = this), this.trackAndCompute() && Ni(this), l.trackingContext = n;
    }
    var i = this.value_;
    if (We(i))
      throw i.cause;
    return i;
  }, t.set = function(n) {
    if (this.setter_) {
      this.isRunningSetter && d(33, this.name_), this.isRunningSetter = !0;
      try {
        this.setter_.call(this.scope_, n);
      } finally {
        this.isRunningSetter = !1;
      }
    } else
      d(34, this.name_);
  }, t.trackAndCompute = function() {
    var n = this.value_, i = (
      /* see #1208 */
      this.dependenciesState_ === g.NOT_TRACKING_
    ), s = this.computeValue_(!0), o = i || We(n) || We(s) || !this.equals_(n, s);
    return o && (this.value_ = s, process.env.NODE_ENV !== "production" && y() && ve({
      observableKind: "computed",
      debugObjectName: this.name_,
      object: this.scope_,
      type: "update",
      oldValue: n,
      newValue: s
    })), o;
  }, t.computeValue_ = function(n) {
    this.isComputing = !0;
    var i = lt(!1), s;
    if (n)
      s = Vn(this, this.derivation, this.scope_);
    else if (l.disableErrorBoundaries === !0)
      s = this.derivation.call(this.scope_);
    else
      try {
        s = this.derivation.call(this.scope_);
      } catch (o) {
        s = new Qe(o);
      }
    return ft(i), this.isComputing = !1, s;
  }, t.suspend_ = function() {
    this.keepAlive_ || (At(this), this.value_ = void 0, process.env.NODE_ENV !== "production" && this.isTracing_ !== H.NONE && console.log("[mobx.trace] Computed value '" + this.name_ + "' was suspended and it will recompute on the next access."));
  }, t.observe_ = function(n, i) {
    var s = this, o = !0, a = void 0;
    return qn(function() {
      var u = s.get();
      if (!o || i) {
        var c = ge();
        n({
          observableKind: "computed",
          debugObjectName: s.name_,
          type: $,
          object: s,
          newValue: u,
          oldValue: a
        }), te(c);
      }
      o = !1, a = u;
    });
  }, t.warnAboutUntrackedRead_ = function() {
    process.env.NODE_ENV !== "production" && (this.isTracing_ !== H.NONE && console.log("[mobx.trace] Computed value '" + this.name_ + "' is being read outside a reactive context. Doing a full recompute."), (typeof this.requiresReaction_ == "boolean" ? this.requiresReaction_ : l.computedRequiresReaction) && console.warn("[mobx] Computed value '" + this.name_ + "' is being read outside a reactive context. Doing a full recompute."));
  }, t.toString = function() {
    return this.name_ + "[" + this.derivation.toString() + "]";
  }, t.valueOf = function() {
    return mn(this.get());
  }, t[Symbol.toPrimitive] = function() {
    return this.valueOf();
  }, Pe(e, [{
    key: "isComputing",
    get: function() {
      return w(this.flags_, e.isComputingMask_);
    },
    set: function(n) {
      this.flags_ = D(this.flags_, e.isComputingMask_, n);
    }
  }, {
    key: "isRunningSetter",
    get: function() {
      return w(this.flags_, e.isRunningSetterMask_);
    },
    set: function(n) {
      this.flags_ = D(this.flags_, e.isRunningSetterMask_, n);
    }
  }, {
    key: "isBeingObserved",
    get: function() {
      return w(this.flags_, e.isBeingObservedMask_);
    },
    set: function(n) {
      this.flags_ = D(this.flags_, e.isBeingObservedMask_, n);
    }
  }, {
    key: "isPendingUnobservation",
    get: function() {
      return w(this.flags_, e.isPendingUnobservationMask_);
    },
    set: function(n) {
      this.flags_ = D(this.flags_, e.isPendingUnobservationMask_, n);
    }
  }, {
    key: "diffValue",
    get: function() {
      return w(this.flags_, e.diffValueMask_) ? 1 : 0;
    },
    set: function(n) {
      this.flags_ = D(this.flags_, e.diffValueMask_, n === 1);
    }
  }]);
}();
k.isComputingMask_ = 1;
k.isRunningSetterMask_ = 2;
k.isBeingObservedMask_ = 4;
k.isPendingUnobservationMask_ = 8;
k.diffValueMask_ = 16;
var dt = /* @__PURE__ */ be("ComputedValue", k), g;
(function(e) {
  e[e.NOT_TRACKING_ = -1] = "NOT_TRACKING_", e[e.UP_TO_DATE_ = 0] = "UP_TO_DATE_", e[e.POSSIBLY_STALE_ = 1] = "POSSIBLY_STALE_", e[e.STALE_ = 2] = "STALE_";
})(g || (g = {}));
var H;
(function(e) {
  e[e.NONE = 0] = "NONE", e[e.LOG = 1] = "LOG", e[e.BREAK = 2] = "BREAK";
})(H || (H = {}));
var Qe = function(t) {
  this.cause = void 0, this.cause = t;
};
function We(e) {
  return e instanceof Qe;
}
function yt(e) {
  switch (e.dependenciesState_) {
    case g.UP_TO_DATE_:
      return !1;
    case g.NOT_TRACKING_:
    case g.STALE_:
      return !0;
    case g.POSSIBLY_STALE_: {
      for (var t = Gt(!0), r = ge(), n = e.observing_, i = n.length, s = 0; s < i; s++) {
        var o = n[s];
        if (dt(o)) {
          if (l.disableErrorBoundaries)
            o.get();
          else
            try {
              o.get();
            } catch {
              return te(r), Ce(t), !0;
            }
          if (e.dependenciesState_ === g.STALE_)
            return te(r), Ce(t), !0;
        }
      }
      return Cn(e), te(r), Ce(t), !1;
    }
  }
}
function X(e) {
  if (process.env.NODE_ENV !== "production") {
    var t = e.observers_.size > 0;
    !l.allowStateChanges && (t || l.enforceActions === "always") && console.warn("[MobX] " + (l.enforceActions ? "Since strict-mode is enabled, changing (observed) observable values without using an action is not allowed. Tried to modify: " : "Side effects like changing state are not allowed at this point. Are you trying to modify state from, for example, a computed value or the render function of a React component? You can wrap side effects in 'runInAction' (or decorate functions with 'action') if needed. Tried to modify: ") + e.name_);
  }
}
function mi(e) {
  process.env.NODE_ENV !== "production" && !l.allowStateReads && l.observableRequiresReaction && console.warn("[mobx] Observable '" + e.name_ + "' being read outside a reactive context.");
}
function Vn(e, t, r) {
  var n = Gt(!0);
  Cn(e), e.newObserving_ = new Array(
    // Reserve constant space for initial dependencies, dynamic space otherwise.
    // See https://github.com/mobxjs/mobx/pull/3833
    e.runId_ === 0 ? 100 : e.observing_.length
  ), e.unboundDepsCount_ = 0, e.runId_ = ++l.runId;
  var i = l.trackingDerivation;
  l.trackingDerivation = e, l.inBatch++;
  var s;
  if (l.disableErrorBoundaries === !0)
    s = t.call(r);
  else
    try {
      s = t.call(r);
    } catch (o) {
      s = new Qe(o);
    }
  return l.inBatch--, l.trackingDerivation = i, yi(e), Ei(e), Ce(n), s;
}
function Ei(e) {
  process.env.NODE_ENV !== "production" && e.observing_.length === 0 && (typeof e.requiresObservable_ == "boolean" ? e.requiresObservable_ : l.reactionRequiresObservable) && console.warn("[mobx] Derivation '" + e.name_ + "' is created/updated without reading any observable value.");
}
function yi(e) {
  for (var t = e.observing_, r = e.observing_ = e.newObserving_, n = g.UP_TO_DATE_, i = 0, s = e.unboundDepsCount_, o = 0; o < s; o++) {
    var a = r[o];
    a.diffValue === 0 && (a.diffValue = 1, i !== o && (r[i] = a), i++), a.dependenciesState_ > n && (n = a.dependenciesState_);
  }
  for (r.length = i, e.newObserving_ = null, s = t.length; s--; ) {
    var u = t[s];
    u.diffValue === 0 && Gn(u, e), u.diffValue = 0;
  }
  for (; i--; ) {
    var c = r[i];
    c.diffValue === 1 && (c.diffValue = 0, Ai(c, e));
  }
  n !== g.UP_TO_DATE_ && (e.dependenciesState_ = n, e.onBecomeStale_());
}
function At(e) {
  var t = e.observing_;
  e.observing_ = [];
  for (var r = t.length; r--; )
    Gn(t[r], e);
  e.dependenciesState_ = g.NOT_TRACKING_;
}
function jn(e) {
  var t = ge();
  try {
    return e();
  } finally {
    te(t);
  }
}
function ge() {
  var e = l.trackingDerivation;
  return l.trackingDerivation = null, e;
}
function te(e) {
  l.trackingDerivation = e;
}
function Gt(e) {
  var t = l.allowStateReads;
  return l.allowStateReads = e, t;
}
function Ce(e) {
  l.allowStateReads = e;
}
function Cn(e) {
  if (e.dependenciesState_ !== g.UP_TO_DATE_) {
    e.dependenciesState_ = g.UP_TO_DATE_;
    for (var t = e.observing_, r = t.length; r--; )
      t[r].lowestObserverState_ = g.UP_TO_DATE_;
  }
}
var _t = function() {
  this.version = 6, this.UNCHANGED = {}, this.trackingDerivation = null, this.trackingContext = null, this.runId = 0, this.mobxGuid = 0, this.inBatch = 0, this.pendingUnobservations = [], this.pendingReactions = [], this.isRunningReactions = !1, this.allowStateChanges = !1, this.allowStateReads = !0, this.enforceActions = !0, this.spyListeners = [], this.globalReactionErrorHandlers = [], this.computedRequiresReaction = !1, this.reactionRequiresObservable = !1, this.observableRequiresReaction = !1, this.disableErrorBoundaries = !1, this.suppressReactionErrors = !1, this.useProxies = !0, this.verifyProxies = !1, this.safeDescriptors = !0;
}, ht = !0, l = /* @__PURE__ */ function() {
  var e = /* @__PURE__ */ Mt();
  return e.__mobxInstanceCount > 0 && !e.__mobxGlobals && (ht = !1), e.__mobxGlobals && e.__mobxGlobals.version !== new _t().version && (ht = !1), ht ? e.__mobxGlobals ? (e.__mobxInstanceCount += 1, e.__mobxGlobals.UNCHANGED || (e.__mobxGlobals.UNCHANGED = {}), e.__mobxGlobals) : (e.__mobxInstanceCount = 1, e.__mobxGlobals = /* @__PURE__ */ new _t()) : (setTimeout(function() {
    d(35);
  }, 1), new _t());
}();
function Ai(e, t) {
  e.observers_.add(t), e.lowestObserverState_ > t.dependenciesState_ && (e.lowestObserverState_ = t.dependenciesState_);
}
function Gn(e, t) {
  e.observers_.delete(t), e.observers_.size === 0 && xn(e);
}
function xn(e) {
  e.isPendingUnobservation === !1 && (e.isPendingUnobservation = !0, l.pendingUnobservations.push(e));
}
function I() {
  l.inBatch++;
}
function B() {
  if (--l.inBatch === 0) {
    kn();
    for (var e = l.pendingUnobservations, t = 0; t < e.length; t++) {
      var r = e[t];
      r.isPendingUnobservation = !1, r.observers_.size === 0 && (r.isBeingObserved && (r.isBeingObserved = !1, r.onBUO()), r instanceof k && r.suspend_());
    }
    l.pendingUnobservations = [];
  }
}
function In(e) {
  mi(e);
  var t = l.trackingDerivation;
  return t !== null ? (t.runId_ !== e.lastAccessedBy_ && (e.lastAccessedBy_ = t.runId_, t.newObserving_[t.unboundDepsCount_++] = e, !e.isBeingObserved && l.trackingContext && (e.isBeingObserved = !0, e.onBO())), e.isBeingObserved) : (e.observers_.size === 0 && l.inBatch > 0 && xn(e), !1);
}
function Bn(e) {
  e.lowestObserverState_ !== g.STALE_ && (e.lowestObserverState_ = g.STALE_, e.observers_.forEach(function(t) {
    t.dependenciesState_ === g.UP_TO_DATE_ && (process.env.NODE_ENV !== "production" && t.isTracing_ !== H.NONE && Un(t, e), t.onBecomeStale_()), t.dependenciesState_ = g.STALE_;
  }));
}
function Ni(e) {
  e.lowestObserverState_ !== g.STALE_ && (e.lowestObserverState_ = g.STALE_, e.observers_.forEach(function(t) {
    t.dependenciesState_ === g.POSSIBLY_STALE_ ? (t.dependenciesState_ = g.STALE_, process.env.NODE_ENV !== "production" && t.isTracing_ !== H.NONE && Un(t, e)) : t.dependenciesState_ === g.UP_TO_DATE_ && (e.lowestObserverState_ = g.UP_TO_DATE_);
  }));
}
function Si(e) {
  e.lowestObserverState_ === g.UP_TO_DATE_ && (e.lowestObserverState_ = g.POSSIBLY_STALE_, e.observers_.forEach(function(t) {
    t.dependenciesState_ === g.UP_TO_DATE_ && (t.dependenciesState_ = g.POSSIBLY_STALE_, t.onBecomeStale_());
  }));
}
function Un(e, t) {
  if (console.log("[mobx.trace] '" + e.name_ + "' is invalidated due to a change in: '" + t.name_ + "'"), e.isTracing_ === H.BREAK) {
    var r = [];
    Hn(Bi(e), r, 1), new Function(`debugger;
/*
Tracing '` + e.name_ + `'

You are entering this break point because derivation '` + e.name_ + "' is being traced and '" + t.name_ + `' is now forcing it to update.
Just follow the stacktrace you should now see in the devtools to see precisely what piece of your code is causing this update
The stackframe you are looking for is at least ~6-8 stack-frames up.

` + (e instanceof k ? e.derivation.toString().replace(/[*]\//g, "/") : "") + `

The dependencies for this derivation are:

` + r.join(`
`) + `
*/
    `)();
  }
}
function Hn(e, t, r) {
  if (t.length >= 1e3) {
    t.push("(and many more)");
    return;
  }
  t.push("" + "	".repeat(r - 1) + e.name), e.dependencies && e.dependencies.forEach(function(n) {
    return Hn(n, t, r + 1);
  });
}
var ne = /* @__PURE__ */ function() {
  function e(r, n, i, s) {
    r === void 0 && (r = process.env.NODE_ENV !== "production" ? "Reaction@" + V() : "Reaction"), this.name_ = void 0, this.onInvalidate_ = void 0, this.errorHandler_ = void 0, this.requiresObservable_ = void 0, this.observing_ = [], this.newObserving_ = [], this.dependenciesState_ = g.NOT_TRACKING_, this.runId_ = 0, this.unboundDepsCount_ = 0, this.flags_ = 0, this.isTracing_ = H.NONE, this.name_ = r, this.onInvalidate_ = n, this.errorHandler_ = i, this.requiresObservable_ = s;
  }
  var t = e.prototype;
  return t.onBecomeStale_ = function() {
    this.schedule_();
  }, t.schedule_ = function() {
    this.isScheduled || (this.isScheduled = !0, l.pendingReactions.push(this), kn());
  }, t.runReaction_ = function() {
    if (!this.isDisposed) {
      I(), this.isScheduled = !1;
      var n = l.trackingContext;
      if (l.trackingContext = this, yt(this)) {
        this.isTrackPending = !0;
        try {
          this.onInvalidate_(), process.env.NODE_ENV !== "production" && this.isTrackPending && y() && ve({
            name: this.name_,
            type: "scheduled-reaction"
          });
        } catch (i) {
          this.reportExceptionInDerivation_(i);
        }
      }
      l.trackingContext = n, B();
    }
  }, t.track = function(n) {
    if (!this.isDisposed) {
      I();
      var i = y(), s;
      process.env.NODE_ENV !== "production" && i && (s = Date.now(), M({
        name: this.name_,
        type: "reaction"
      })), this.isRunning = !0;
      var o = l.trackingContext;
      l.trackingContext = this;
      var a = Vn(this, n, void 0);
      l.trackingContext = o, this.isRunning = !1, this.isTrackPending = !1, this.isDisposed && At(this), We(a) && this.reportExceptionInDerivation_(a.cause), process.env.NODE_ENV !== "production" && i && P({
        time: Date.now() - s
      }), B();
    }
  }, t.reportExceptionInDerivation_ = function(n) {
    var i = this;
    if (this.errorHandler_) {
      this.errorHandler_(n, this);
      return;
    }
    if (l.disableErrorBoundaries)
      throw n;
    var s = process.env.NODE_ENV !== "production" ? "[mobx] Encountered an uncaught exception that was thrown by a reaction or observer component, in: '" + this + "'" : "[mobx] uncaught error in '" + this + "'";
    l.suppressReactionErrors ? process.env.NODE_ENV !== "production" && console.warn("[mobx] (error in reaction '" + this.name_ + "' suppressed, fix error of causing action below)") : console.error(s, n), process.env.NODE_ENV !== "production" && y() && ve({
      type: "error",
      name: this.name_,
      message: s,
      error: "" + n
    }), l.globalReactionErrorHandlers.forEach(function(o) {
      return o(n, i);
    });
  }, t.dispose = function() {
    this.isDisposed || (this.isDisposed = !0, this.isRunning || (I(), At(this), B()));
  }, t.getDisposer_ = function(n) {
    var i = this, s = function o() {
      i.dispose(), n == null || n.removeEventListener == null || n.removeEventListener("abort", o);
    };
    return n == null || n.addEventListener == null || n.addEventListener("abort", s), s[_] = this, s;
  }, t.toString = function() {
    return "Reaction[" + this.name_ + "]";
  }, t.trace = function(n) {
    n === void 0 && (n = !1), Ki(this, n);
  }, Pe(e, [{
    key: "isDisposed",
    get: function() {
      return w(this.flags_, e.isDisposedMask_);
    },
    set: function(n) {
      this.flags_ = D(this.flags_, e.isDisposedMask_, n);
    }
  }, {
    key: "isScheduled",
    get: function() {
      return w(this.flags_, e.isScheduledMask_);
    },
    set: function(n) {
      this.flags_ = D(this.flags_, e.isScheduledMask_, n);
    }
  }, {
    key: "isTrackPending",
    get: function() {
      return w(this.flags_, e.isTrackPendingMask_);
    },
    set: function(n) {
      this.flags_ = D(this.flags_, e.isTrackPendingMask_, n);
    }
  }, {
    key: "isRunning",
    get: function() {
      return w(this.flags_, e.isRunningMask_);
    },
    set: function(n) {
      this.flags_ = D(this.flags_, e.isRunningMask_, n);
    }
  }, {
    key: "diffValue",
    get: function() {
      return w(this.flags_, e.diffValueMask_) ? 1 : 0;
    },
    set: function(n) {
      this.flags_ = D(this.flags_, e.diffValueMask_, n === 1);
    }
  }]);
}();
ne.isDisposedMask_ = 1;
ne.isScheduledMask_ = 2;
ne.isTrackPendingMask_ = 4;
ne.isRunningMask_ = 8;
ne.diffValueMask_ = 16;
var Wt = 100, Ti = function(t) {
  return t();
};
function kn() {
  l.inBatch > 0 || l.isRunningReactions || Ti(Li);
}
function Li() {
  l.isRunningReactions = !0;
  for (var e = l.pendingReactions, t = 0; e.length > 0; ) {
    ++t === Wt && (console.error(process.env.NODE_ENV !== "production" ? "Reaction doesn't converge to a stable state after " + Wt + " iterations." + (" Probably there is a cycle in the reactive function: " + e[0]) : "[mobx] cycle in reaction: " + e[0]), e.splice(0));
    for (var r = e.splice(0), n = 0, i = r.length; n < i; n++)
      r[n].runReaction_();
  }
  l.isRunningReactions = !1;
}
var et = /* @__PURE__ */ be("Reaction", ne);
function y() {
  return process.env.NODE_ENV !== "production" && !!l.spyListeners.length;
}
function ve(e) {
  if (process.env.NODE_ENV !== "production" && l.spyListeners.length)
    for (var t = l.spyListeners, r = 0, n = t.length; r < n; r++)
      t[r](e);
}
function M(e) {
  if (process.env.NODE_ENV !== "production") {
    var t = Z({}, e, {
      spyReportStart: !0
    });
    ve(t);
  }
}
var Ri = {
  type: "report-end",
  spyReportEnd: !0
};
function P(e) {
  process.env.NODE_ENV !== "production" && ve(e ? Z({}, e, {
    type: "report-end",
    spyReportEnd: !0
  }) : Ri);
}
function wi(e) {
  return process.env.NODE_ENV === "production" ? (console.warn("[mobx.spy] Is a no-op in production builds"), function() {
  }) : (l.spyListeners.push(e), Vt(function() {
    l.spyListeners = l.spyListeners.filter(function(t) {
      return t !== e;
    });
  }));
}
var xt = "action", Di = "action.bound", $n = "autoAction", Mi = "autoAction.bound", Kn = "<unnamed action>", Nt = /* @__PURE__ */ He(xt), Pi = /* @__PURE__ */ He(Di, {
  bound: !0
}), St = /* @__PURE__ */ He($n, {
  autoAction: !0
}), Vi = /* @__PURE__ */ He(Mi, {
  autoAction: !0,
  bound: !0
});
function Fn(e) {
  var t = function(n, i) {
    if (m(n))
      return oe(n.name || Kn, n, e);
    if (m(i))
      return oe(n, i, e);
    if (Ue(i))
      return (e ? St : Nt).decorate_20223_(n, i);
    if (he(i))
      return Be(n, i, e ? St : Nt);
    if (he(n))
      return J(He(e ? $n : xt, {
        name: n,
        autoAction: e
      }));
    process.env.NODE_ENV !== "production" && d("Invalid arguments for `action`");
  };
  return t;
}
var ie = /* @__PURE__ */ Fn(!1);
Object.assign(ie, Nt);
var Ge = /* @__PURE__ */ Fn(!0);
Object.assign(Ge, St);
ie.bound = /* @__PURE__ */ J(Pi);
Ge.bound = /* @__PURE__ */ J(Vi);
function Xt(e) {
  return Mn(e.name || Kn, !1, e, this, void 0);
}
function Le(e) {
  return m(e) && e.isMobxAction === !0;
}
function qn(e, t) {
  var r, n, i, s;
  t === void 0 && (t = Pt), process.env.NODE_ENV !== "production" && (m(e) || d("Autorun expects a function as first argument"), Le(e) && d("Autorun does not accept actions since actions are untrackable"));
  var o = (r = (n = t) == null ? void 0 : n.name) != null ? r : process.env.NODE_ENV !== "production" ? e.name || "Autorun@" + V() : "Autorun", a = !t.scheduler && !t.delay, u;
  if (a)
    u = new ne(o, function() {
      this.track(p);
    }, t.onError, t.requiresObservable);
  else {
    var c = zn(t), f = !1;
    u = new ne(o, function() {
      f || (f = !0, c(function() {
        f = !1, u.isDisposed || u.track(p);
      }));
    }, t.onError, t.requiresObservable);
  }
  function p() {
    e(u);
  }
  return (i = t) != null && (i = i.signal) != null && i.aborted || u.schedule_(), u.getDisposer_((s = t) == null ? void 0 : s.signal);
}
var ji = function(t) {
  return t();
};
function zn(e) {
  return e.scheduler ? e.scheduler : e.delay ? function(t) {
    return setTimeout(t, e.delay);
  } : ji;
}
function Wn(e, t, r) {
  var n, i, s;
  r === void 0 && (r = Pt), process.env.NODE_ENV !== "production" && ((!m(e) || !m(t)) && d("First and second argument to reaction should be functions"), S(r) || d("Third argument of reactions should be an object"));
  var o = (n = r.name) != null ? n : process.env.NODE_ENV !== "production" ? "Reaction@" + V() : "Reaction", a = ie(o, r.onError ? Ci(r.onError, t) : t), u = !r.scheduler && !r.delay, c = zn(r), f = !0, p = !1, v, C = r.compareStructural ? Te.structural : r.equals || Te.default, A = new ne(o, function() {
    f || u ? T() : p || (p = !0, c(T));
  }, r.onError, r.requiresObservable);
  function T() {
    if (p = !1, !A.isDisposed) {
      var L = !1, le = v;
      A.track(function() {
        var Ee = Pn(!1, function() {
          return e(A);
        });
        L = f || !C(v, Ee), v = Ee;
      }), (f && r.fireImmediately || !f && L) && a(v, le, A), f = !1;
    }
  }
  return (i = r) != null && (i = i.signal) != null && i.aborted || A.schedule_(), A.getDisposer_((s = r) == null ? void 0 : s.signal);
}
function Ci(e, t) {
  return function() {
    try {
      return t.apply(this, arguments);
    } catch (r) {
      e.call(this, r);
    }
  };
}
var Gi = "onBO", xi = "onBUO";
function Ii(e, t, r) {
  return Yn(Gi, e, t, r);
}
function Xn(e, t, r) {
  return Yn(xi, e, t, r);
}
function Yn(e, t, r, n) {
  var i = De(t), s = m(n) ? n : r, o = e + "L";
  return i[o] ? i[o].add(s) : i[o] = /* @__PURE__ */ new Set([s]), function() {
    var a = i[o];
    a && (a.delete(s), a.size === 0 && delete i[o]);
  };
}
function Jn(e, t, r, n) {
  process.env.NODE_ENV !== "production" && (arguments.length > 4 && d("'extendObservable' expected 2-4 arguments"), typeof e != "object" && d("'extendObservable' expects an object as first argument"), ue(e) && d("'extendObservable' should not be used on maps, use map.merge instead"), S(t) || d("'extendObservable' only accepts plain objects as second argument"), (we(t) || we(r)) && d("Extending an object with another observable (object) is not supported"));
  var i = yr(t);
  return ce(function() {
    var s = Oe(e, n)[_];
    Se(i).forEach(function(o) {
      s.extend_(
        o,
        i[o],
        // must pass "undefined" for { key: undefined }
        r && o in r ? r[o] : !0
      );
    });
  }), e;
}
function Bi(e, t) {
  return Zn(De(e, t));
}
function Zn(e) {
  var t = {
    name: e.name_
  };
  return e.observing_ && e.observing_.length > 0 && (t.dependencies = Ui(e.observing_).map(Zn)), t;
}
function Ui(e) {
  return Array.from(new Set(e));
}
var Hi = 0;
function Qn() {
  this.message = "FLOW_CANCELLED";
}
Qn.prototype = /* @__PURE__ */ Object.create(Error.prototype);
var pt = /* @__PURE__ */ Nn("flow"), ki = /* @__PURE__ */ Nn("flow.bound", {
  bound: !0
}), Re = /* @__PURE__ */ Object.assign(function(t, r) {
  if (Ue(r))
    return pt.decorate_20223_(t, r);
  if (he(r))
    return Be(t, r, pt);
  process.env.NODE_ENV !== "production" && arguments.length !== 1 && d("Flow expects single argument with generator function");
  var n = t, i = n.name || "<unnamed flow>", s = function() {
    var a = this, u = arguments, c = ++Hi, f = ie(i + " - runid: " + c + " - init", n).apply(a, u), p, v = void 0, C = new Promise(function(A, T) {
      var L = 0;
      p = T;
      function le(R) {
        v = void 0;
        var re;
        try {
          re = ie(i + " - runid: " + c + " - yield " + L++, f.next).call(f, R);
        } catch (fe) {
          return T(fe);
        }
        Ve(re);
      }
      function Ee(R) {
        v = void 0;
        var re;
        try {
          re = ie(i + " - runid: " + c + " - yield " + L++, f.throw).call(f, R);
        } catch (fe) {
          return T(fe);
        }
        Ve(re);
      }
      function Ve(R) {
        if (m(R == null ? void 0 : R.then)) {
          R.then(Ve, T);
          return;
        }
        return R.done ? A(R.value) : (v = Promise.resolve(R.value), v.then(le, Ee));
      }
      le(void 0);
    });
    return C.cancel = ie(i + " - runid: " + c + " - cancel", function() {
      try {
        v && Yt(v);
        var A = f.return(void 0), T = Promise.resolve(A.value);
        T.then(ye, ye), Yt(T), p(new Qn());
      } catch (L) {
        p(L);
      }
    }), C;
  };
  return s.isMobXFlow = !0, s;
}, pt);
Re.bound = /* @__PURE__ */ J(ki);
function Yt(e) {
  m(e.cancel) && e.cancel();
}
function xe(e) {
  return (e == null ? void 0 : e.isMobXFlow) === !0;
}
function $i(e, t) {
  return e ? me(e) || !!e[_] || jt(e) || et(e) || dt(e) : !1;
}
function we(e) {
  return process.env.NODE_ENV !== "production" && arguments.length !== 1 && d("isObservable expects only 1 argument. Use isObservableProp to inspect the observability of a property"), $i(e);
}
function Ki() {
  if (process.env.NODE_ENV !== "production") {
    for (var e = !1, t = arguments.length, r = new Array(t), n = 0; n < t; n++)
      r[n] = arguments[n];
    typeof r[r.length - 1] == "boolean" && (e = r.pop());
    var i = Fi(r);
    if (!i)
      return d("'trace(break?)' can only be used inside a tracked computed value or a Reaction. Consider passing in the computed value or reaction explicitly");
    i.isTracing_ === H.NONE && console.log("[mobx.trace] '" + i.name_ + "' tracing enabled"), i.isTracing_ = e ? H.BREAK : H.LOG;
  }
}
function Fi(e) {
  switch (e.length) {
    case 0:
      return l.trackingDerivation;
    case 1:
      return De(e[0]);
    case 2:
      return De(e[0], e[1]);
  }
}
function ee(e, t) {
  t === void 0 && (t = void 0), I();
  try {
    return e.apply(t);
  } finally {
    B();
  }
}
function qi(e, t, r) {
  return arguments.length === 1 || t && typeof t == "object" ? zi(e, t) : er(e, t, {});
}
function er(e, t, r) {
  var n;
  if (typeof r.timeout == "number") {
    var i = new Error("WHEN_TIMEOUT");
    n = setTimeout(function() {
      if (!o[_].isDisposed)
        if (o(), r.onError)
          r.onError(i);
        else
          throw i;
    }, r.timeout);
  }
  r.name = process.env.NODE_ENV !== "production" ? r.name || "When@" + V() : "When";
  var s = oe(process.env.NODE_ENV !== "production" ? r.name + "-effect" : "When-effect", t), o = qn(function(a) {
    var u = Pn(!1, e);
    u && (a.dispose(), n && clearTimeout(n), s());
  }, r);
  return o;
}
function zi(e, t) {
  var r;
  if (process.env.NODE_ENV !== "production" && t && t.onError)
    return d("the options 'onError' and 'promise' cannot be combined");
  if (t != null && (r = t.signal) != null && r.aborted)
    return Object.assign(Promise.reject(new Error("WHEN_ABORTED")), {
      cancel: function() {
        return null;
      }
    });
  var n, i, s = new Promise(function(o, a) {
    var u, c = er(e, o, Z({}, t, {
      onError: a
    }));
    n = function() {
      c(), a(new Error("WHEN_CANCELLED"));
    }, i = function() {
      c(), a(new Error("WHEN_ABORTED"));
    }, t == null || (u = t.signal) == null || u.addEventListener == null || u.addEventListener("abort", i);
  }).finally(function() {
    var o;
    return t == null || (o = t.signal) == null || o.removeEventListener == null ? void 0 : o.removeEventListener("abort", i);
  });
  return s.cancel = n, s;
}
function de(e) {
  return e[_];
}
var Wi = {
  has: function(t, r) {
    return process.env.NODE_ENV !== "production" && l.trackingDerivation && je("detect new properties using the 'in' operator. Use 'has' from 'mobx' instead."), de(t).has_(r);
  },
  get: function(t, r) {
    return de(t).get_(r);
  },
  set: function(t, r, n) {
    var i;
    return he(r) ? (process.env.NODE_ENV !== "production" && !de(t).values_.has(r) && je("add a new observable property through direct assignment. Use 'set' from 'mobx' instead."), (i = de(t).set_(r, n, !0)) != null ? i : !0) : !1;
  },
  deleteProperty: function(t, r) {
    var n;
    return process.env.NODE_ENV !== "production" && je("delete properties from an observable object. Use 'remove' from 'mobx' instead."), he(r) ? (n = de(t).delete_(r, !0)) != null ? n : !0 : !1;
  },
  defineProperty: function(t, r, n) {
    var i;
    return process.env.NODE_ENV !== "production" && je("define property on an observable object. Use 'defineProperty' from 'mobx' instead."), (i = de(t).defineProperty_(r, n)) != null ? i : !0;
  },
  ownKeys: function(t) {
    return process.env.NODE_ENV !== "production" && l.trackingDerivation && je("iterate keys to detect added / removed properties. Use 'keys' from 'mobx' instead."), de(t).ownKeys_();
  },
  preventExtensions: function(t) {
    d(13);
  }
};
function Xi(e, t) {
  var r, n;
  return vn(), e = Oe(e, t), (n = (r = e[_]).proxy_) != null ? n : r.proxy_ = new Proxy(e, Wi);
}
function G(e) {
  return e.interceptors_ !== void 0 && e.interceptors_.length > 0;
}
function ke(e, t) {
  var r = e.interceptors_ || (e.interceptors_ = []);
  return r.push(t), Vt(function() {
    var n = r.indexOf(t);
    n !== -1 && r.splice(n, 1);
  });
}
function x(e, t) {
  var r = ge();
  try {
    for (var n = [].concat(e.interceptors_ || []), i = 0, s = n.length; i < s && (t = n[i](t), t && !t.type && d(14), !!t); i++)
      ;
    return t;
  } finally {
    te(r);
  }
}
function K(e) {
  return e.changeListeners_ !== void 0 && e.changeListeners_.length > 0;
}
function $e(e, t) {
  var r = e.changeListeners_ || (e.changeListeners_ = []);
  return r.push(t), Vt(function() {
    var n = r.indexOf(t);
    n !== -1 && r.splice(n, 1);
  });
}
function F(e, t) {
  var r = ge(), n = e.changeListeners_;
  if (n) {
    n = n.slice();
    for (var i = 0, s = n.length; i < s; i++)
      n[i](t);
    te(r);
  }
}
function Yi(e, t, r) {
  return ce(function() {
    var n, i = Oe(e, r)[_];
    process.env.NODE_ENV !== "production" && t && e[N] && d("makeObservable second arg must be nullish when using decorators. Mixing @decorator syntax with annotations is not supported."), (n = t) != null || (t = Rr(e)), Se(t).forEach(function(s) {
      return i.make_(s, t[s]);
    });
  }), e;
}
var vt = /* @__PURE__ */ Symbol("mobx-keys");
function Ke(e, t, r) {
  return process.env.NODE_ENV !== "production" && (!S(e) && !S(Object.getPrototypeOf(e)) && d("'makeAutoObservable' can only be used for classes that don't have a superclass"), me(e) && d("makeAutoObservable can only be used on objects not already made observable")), S(e) ? Jn(e, e, t, r) : (ce(function() {
    var n = Oe(e, r)[_];
    if (!e[vt]) {
      var i = Object.getPrototypeOf(e), s = new Set([].concat(Se(e), Se(i)));
      s.delete("constructor"), s.delete(_), Ie(i, vt, s);
    }
    e[vt].forEach(function(o) {
      return n.make_(
        o,
        // must pass "undefined" for { key: undefined }
        t && o in t ? t[o] : !0
      );
    });
  }), e);
}
var Jt = "splice", $ = "update", Ji = 1e4, Zi = {
  get: function(t, r) {
    var n = t[_];
    return r === _ ? n : r === "length" ? n.getArrayLength_() : typeof r == "string" && !isNaN(r) ? n.get_(parseInt(r)) : U(tt, r) ? tt[r] : t[r];
  },
  set: function(t, r, n) {
    var i = t[_];
    return r === "length" && i.setArrayLength_(n), typeof r == "symbol" || isNaN(r) ? t[r] = n : i.set_(parseInt(r), n), !0;
  },
  preventExtensions: function() {
    d(15);
  }
}, It = /* @__PURE__ */ function() {
  function e(r, n, i, s) {
    r === void 0 && (r = process.env.NODE_ENV !== "production" ? "ObservableArray@" + V() : "ObservableArray"), this.owned_ = void 0, this.legacyMode_ = void 0, this.atom_ = void 0, this.values_ = [], this.interceptors_ = void 0, this.changeListeners_ = void 0, this.enhancer_ = void 0, this.dehancer = void 0, this.proxy_ = void 0, this.lastKnownLength_ = 0, this.owned_ = i, this.legacyMode_ = s, this.atom_ = new ae(r), this.enhancer_ = function(o, a) {
      return n(o, a, process.env.NODE_ENV !== "production" ? r + "[..]" : "ObservableArray[..]");
    };
  }
  var t = e.prototype;
  return t.dehanceValue_ = function(n) {
    return this.dehancer !== void 0 ? this.dehancer(n) : n;
  }, t.dehanceValues_ = function(n) {
    return this.dehancer !== void 0 && n.length > 0 ? n.map(this.dehancer) : n;
  }, t.intercept_ = function(n) {
    return ke(this, n);
  }, t.observe_ = function(n, i) {
    return i === void 0 && (i = !1), i && n({
      observableKind: "array",
      object: this.proxy_,
      debugObjectName: this.atom_.name_,
      type: "splice",
      index: 0,
      added: this.values_.slice(),
      addedCount: this.values_.length,
      removed: [],
      removedCount: 0
    }), $e(this, n);
  }, t.getArrayLength_ = function() {
    return this.atom_.reportObserved(), this.values_.length;
  }, t.setArrayLength_ = function(n) {
    (typeof n != "number" || isNaN(n) || n < 0) && d("Out of range: " + n);
    var i = this.values_.length;
    if (n !== i)
      if (n > i) {
        for (var s = new Array(n - i), o = 0; o < n - i; o++)
          s[o] = void 0;
        this.spliceWithArray_(i, 0, s);
      } else
        this.spliceWithArray_(n, i - n);
  }, t.updateArrayLength_ = function(n, i) {
    n !== this.lastKnownLength_ && d(16), this.lastKnownLength_ += i, this.legacyMode_ && i > 0 && or(n + i + 1);
  }, t.spliceWithArray_ = function(n, i, s) {
    var o = this;
    X(this.atom_);
    var a = this.values_.length;
    if (n === void 0 ? n = 0 : n > a ? n = a : n < 0 && (n = Math.max(0, a + n)), arguments.length === 1 ? i = a - n : i == null ? i = 0 : i = Math.max(0, Math.min(i, a - n)), s === void 0 && (s = Ye), G(this)) {
      var u = x(this, {
        object: this.proxy_,
        type: Jt,
        index: n,
        removedCount: i,
        added: s
      });
      if (!u)
        return Ye;
      i = u.removedCount, s = u.added;
    }
    if (s = s.length === 0 ? s : s.map(function(p) {
      return o.enhancer_(p, void 0);
    }), this.legacyMode_ || process.env.NODE_ENV !== "production") {
      var c = s.length - i;
      this.updateArrayLength_(a, c);
    }
    var f = this.spliceItemsIntoValues_(n, i, s);
    return (i !== 0 || s.length !== 0) && this.notifyArraySplice_(n, s, f), this.dehanceValues_(f);
  }, t.spliceItemsIntoValues_ = function(n, i, s) {
    if (s.length < Ji) {
      var o;
      return (o = this.values_).splice.apply(o, [n, i].concat(s));
    } else {
      var a = this.values_.slice(n, n + i), u = this.values_.slice(n + i);
      this.values_.length += s.length - i;
      for (var c = 0; c < s.length; c++)
        this.values_[n + c] = s[c];
      for (var f = 0; f < u.length; f++)
        this.values_[n + s.length + f] = u[f];
      return a;
    }
  }, t.notifyArrayChildUpdate_ = function(n, i, s) {
    var o = !this.owned_ && y(), a = K(this), u = a || o ? {
      observableKind: "array",
      object: this.proxy_,
      type: $,
      debugObjectName: this.atom_.name_,
      index: n,
      newValue: i,
      oldValue: s
    } : null;
    process.env.NODE_ENV !== "production" && o && M(u), this.atom_.reportChanged(), a && F(this, u), process.env.NODE_ENV !== "production" && o && P();
  }, t.notifyArraySplice_ = function(n, i, s) {
    var o = !this.owned_ && y(), a = K(this), u = a || o ? {
      observableKind: "array",
      object: this.proxy_,
      debugObjectName: this.atom_.name_,
      type: Jt,
      index: n,
      removed: s,
      added: i,
      removedCount: s.length,
      addedCount: i.length
    } : null;
    process.env.NODE_ENV !== "production" && o && M(u), this.atom_.reportChanged(), a && F(this, u), process.env.NODE_ENV !== "production" && o && P();
  }, t.get_ = function(n) {
    if (this.legacyMode_ && n >= this.values_.length) {
      console.warn(process.env.NODE_ENV !== "production" ? "[mobx.array] Attempt to read an array index (" + n + ") that is out of bounds (" + this.values_.length + "). Please check length first. Out of bound indices will not be tracked by MobX" : "[mobx] Out of bounds read: " + n);
      return;
    }
    return this.atom_.reportObserved(), this.dehanceValue_(this.values_[n]);
  }, t.set_ = function(n, i) {
    var s = this.values_;
    if (this.legacyMode_ && n > s.length && d(17, n, s.length), n < s.length) {
      X(this.atom_);
      var o = s[n];
      if (G(this)) {
        var a = x(this, {
          type: $,
          object: this.proxy_,
          // since "this" is the real array we need to pass its proxy
          index: n,
          newValue: i
        });
        if (!a)
          return;
        i = a.newValue;
      }
      i = this.enhancer_(i, o);
      var u = i !== o;
      u && (s[n] = i, this.notifyArrayChildUpdate_(n, i, o));
    } else {
      for (var c = new Array(n + 1 - s.length), f = 0; f < c.length - 1; f++)
        c[f] = void 0;
      c[c.length - 1] = i, this.spliceWithArray_(s.length, 0, c);
    }
  }, e;
}();
function Qi(e, t, r, n) {
  return r === void 0 && (r = process.env.NODE_ENV !== "production" ? "ObservableArray@" + V() : "ObservableArray"), n === void 0 && (n = !1), vn(), ce(function() {
    var i = new It(r, t, n, !1);
    gn(i.values_, _, i);
    var s = new Proxy(i.values_, Zi);
    return i.proxy_ = s, e && e.length && i.spliceWithArray_(0, 0, e), s;
  });
}
var tt = {
  clear: function() {
    return this.splice(0);
  },
  replace: function(t) {
    var r = this[_];
    return r.spliceWithArray_(0, r.values_.length, t);
  },
  // Used by JSON.stringify
  toJSON: function() {
    return this.slice();
  },
  /*
   * functions that do alter the internal structure of the array, (based on lib.es6.d.ts)
   * since these functions alter the inner structure of the array, the have side effects.
   * Because the have side effects, they should not be used in computed function,
   * and for that reason the do not call dependencyState.notifyObserved
   */
  splice: function(t, r) {
    for (var n = arguments.length, i = new Array(n > 2 ? n - 2 : 0), s = 2; s < n; s++)
      i[s - 2] = arguments[s];
    var o = this[_];
    switch (arguments.length) {
      case 0:
        return [];
      case 1:
        return o.spliceWithArray_(t);
      case 2:
        return o.spliceWithArray_(t, r);
    }
    return o.spliceWithArray_(t, r, i);
  },
  spliceWithArray: function(t, r, n) {
    return this[_].spliceWithArray_(t, r, n);
  },
  push: function() {
    for (var t = this[_], r = arguments.length, n = new Array(r), i = 0; i < r; i++)
      n[i] = arguments[i];
    return t.spliceWithArray_(t.values_.length, 0, n), t.values_.length;
  },
  pop: function() {
    return this.splice(Math.max(this[_].values_.length - 1, 0), 1)[0];
  },
  shift: function() {
    return this.splice(0, 1)[0];
  },
  unshift: function() {
    for (var t = this[_], r = arguments.length, n = new Array(r), i = 0; i < r; i++)
      n[i] = arguments[i];
    return t.spliceWithArray_(0, 0, n), t.values_.length;
  },
  reverse: function() {
    return l.trackingDerivation && d(37, "reverse"), this.replace(this.slice().reverse()), this;
  },
  sort: function() {
    l.trackingDerivation && d(37, "sort");
    var t = this.slice();
    return t.sort.apply(t, arguments), this.replace(t), this;
  },
  remove: function(t) {
    var r = this[_], n = r.dehanceValues_(r.values_).indexOf(t);
    return n > -1 ? (this.splice(n, 1), !0) : !1;
  }
};
O("at", j);
O("concat", j);
O("flat", j);
O("includes", j);
O("indexOf", j);
O("join", j);
O("lastIndexOf", j);
O("slice", j);
O("toString", j);
O("toLocaleString", j);
O("toSorted", j);
O("toSpliced", j);
O("with", j);
O("every", q);
O("filter", q);
O("find", q);
O("findIndex", q);
O("findLast", q);
O("findLastIndex", q);
O("flatMap", q);
O("forEach", q);
O("map", q);
O("some", q);
O("toReversed", q);
O("reduce", tr);
O("reduceRight", tr);
function O(e, t) {
  typeof Array.prototype[e] == "function" && (tt[e] = t(e));
}
function j(e) {
  return function() {
    var t = this[_];
    t.atom_.reportObserved();
    var r = t.dehanceValues_(t.values_);
    return r[e].apply(r, arguments);
  };
}
function q(e) {
  return function(t, r) {
    var n = this, i = this[_];
    i.atom_.reportObserved();
    var s = i.dehanceValues_(i.values_);
    return s[e](function(o, a) {
      return t.call(r, o, a, n);
    });
  };
}
function tr(e) {
  return function() {
    var t = this, r = this[_];
    r.atom_.reportObserved();
    var n = r.dehanceValues_(r.values_), i = arguments[0];
    return arguments[0] = function(s, o, a) {
      return i(s, o, a, t);
    }, n[e].apply(n, arguments);
  };
}
var es = /* @__PURE__ */ be("ObservableArrayAdministration", It);
function Fe(e) {
  return st(e) && es(e[_]);
}
var ts = {}, se = "add", nt = "delete", nr = /* @__PURE__ */ function() {
  function e(r, n, i) {
    var s = this;
    n === void 0 && (n = pe), i === void 0 && (i = process.env.NODE_ENV !== "production" ? "ObservableMap@" + V() : "ObservableMap"), this.enhancer_ = void 0, this.name_ = void 0, this[_] = ts, this.data_ = void 0, this.hasMap_ = void 0, this.keysAtom_ = void 0, this.interceptors_ = void 0, this.changeListeners_ = void 0, this.dehancer = void 0, this.enhancer_ = n, this.name_ = i, m(Map) || d(18), ce(function() {
      s.keysAtom_ = yn(process.env.NODE_ENV !== "production" ? s.name_ + ".keys()" : "ObservableMap.keys()"), s.data_ = /* @__PURE__ */ new Map(), s.hasMap_ = /* @__PURE__ */ new Map(), r && s.merge(r);
    });
  }
  var t = e.prototype;
  return t.has_ = function(n) {
    return this.data_.has(n);
  }, t.has = function(n) {
    var i = this;
    if (!l.trackingDerivation)
      return this.has_(n);
    var s = this.hasMap_.get(n);
    if (!s) {
      var o = s = new _e(this.has_(n), at, process.env.NODE_ENV !== "production" ? this.name_ + "." + gt(n) + "?" : "ObservableMap.key?", !1);
      this.hasMap_.set(n, o), Xn(o, function() {
        return i.hasMap_.delete(n);
      });
    }
    return s.get();
  }, t.set = function(n, i) {
    var s = this.has_(n);
    if (G(this)) {
      var o = x(this, {
        type: s ? $ : se,
        object: this,
        newValue: i,
        name: n
      });
      if (!o)
        return this;
      i = o.newValue;
    }
    return s ? this.updateValue_(n, i) : this.addValue_(n, i), this;
  }, t.delete = function(n) {
    var i = this;
    if (X(this.keysAtom_), G(this)) {
      var s = x(this, {
        type: nt,
        object: this,
        name: n
      });
      if (!s)
        return !1;
    }
    if (this.has_(n)) {
      var o = y(), a = K(this), u = a || o ? {
        observableKind: "map",
        debugObjectName: this.name_,
        type: nt,
        object: this,
        oldValue: this.data_.get(n).value_,
        name: n
      } : null;
      return process.env.NODE_ENV !== "production" && o && M(u), ee(function() {
        var c;
        i.keysAtom_.reportChanged(), (c = i.hasMap_.get(n)) == null || c.setNewValue_(!1);
        var f = i.data_.get(n);
        f.setNewValue_(void 0), i.data_.delete(n);
      }), a && F(this, u), process.env.NODE_ENV !== "production" && o && P(), !0;
    }
    return !1;
  }, t.updateValue_ = function(n, i) {
    var s = this.data_.get(n);
    if (i = s.prepareNewValue_(i), i !== l.UNCHANGED) {
      var o = y(), a = K(this), u = a || o ? {
        observableKind: "map",
        debugObjectName: this.name_,
        type: $,
        object: this,
        oldValue: s.value_,
        name: n,
        newValue: i
      } : null;
      process.env.NODE_ENV !== "production" && o && M(u), s.setNewValue_(i), a && F(this, u), process.env.NODE_ENV !== "production" && o && P();
    }
  }, t.addValue_ = function(n, i) {
    var s = this;
    X(this.keysAtom_), ee(function() {
      var c, f = new _e(i, s.enhancer_, process.env.NODE_ENV !== "production" ? s.name_ + "." + gt(n) : "ObservableMap.key", !1);
      s.data_.set(n, f), i = f.value_, (c = s.hasMap_.get(n)) == null || c.setNewValue_(!0), s.keysAtom_.reportChanged();
    });
    var o = y(), a = K(this), u = a || o ? {
      observableKind: "map",
      debugObjectName: this.name_,
      type: se,
      object: this,
      name: n,
      newValue: i
    } : null;
    process.env.NODE_ENV !== "production" && o && M(u), a && F(this, u), process.env.NODE_ENV !== "production" && o && P();
  }, t.get = function(n) {
    return this.has(n) ? this.dehanceValue_(this.data_.get(n).get()) : this.dehanceValue_(void 0);
  }, t.dehanceValue_ = function(n) {
    return this.dehancer !== void 0 ? this.dehancer(n) : n;
  }, t.keys = function() {
    return this.keysAtom_.reportObserved(), this.data_.keys();
  }, t.values = function() {
    var n = this, i = this.keys();
    return Zt({
      next: function() {
        var o = i.next(), a = o.done, u = o.value;
        return {
          done: a,
          value: a ? void 0 : n.get(u)
        };
      }
    });
  }, t.entries = function() {
    var n = this, i = this.keys();
    return Zt({
      next: function() {
        var o = i.next(), a = o.done, u = o.value;
        return {
          done: a,
          value: a ? void 0 : [u, n.get(u)]
        };
      }
    });
  }, t[Symbol.iterator] = function() {
    return this.entries();
  }, t.forEach = function(n, i) {
    for (var s = Ae(this), o; !(o = s()).done; ) {
      var a = o.value, u = a[0], c = a[1];
      n.call(i, c, u, this);
    }
  }, t.merge = function(n) {
    var i = this;
    return ue(n) && (n = new Map(n)), ee(function() {
      S(n) ? Er(n).forEach(function(s) {
        return i.set(s, n[s]);
      }) : Array.isArray(n) ? n.forEach(function(s) {
        var o = s[0], a = s[1];
        return i.set(o, a);
      }) : Me(n) ? (mr(n) || d(19, n), n.forEach(function(s, o) {
        return i.set(o, s);
      })) : n != null && d(20, n);
    }), this;
  }, t.clear = function() {
    var n = this;
    ee(function() {
      jn(function() {
        for (var i = Ae(n.keys()), s; !(s = i()).done; ) {
          var o = s.value;
          n.delete(o);
        }
      });
    });
  }, t.replace = function(n) {
    var i = this;
    return ee(function() {
      for (var s = ns(n), o = /* @__PURE__ */ new Map(), a = !1, u = Ae(i.data_.keys()), c; !(c = u()).done; ) {
        var f = c.value;
        if (!s.has(f)) {
          var p = i.delete(f);
          if (p)
            a = !0;
          else {
            var v = i.data_.get(f);
            o.set(f, v);
          }
        }
      }
      for (var C = Ae(s.entries()), A; !(A = C()).done; ) {
        var T = A.value, L = T[0], le = T[1], Ee = i.data_.has(L);
        if (i.set(L, le), i.data_.has(L)) {
          var Ve = i.data_.get(L);
          o.set(L, Ve), Ee || (a = !0);
        }
      }
      if (!a)
        if (i.data_.size !== o.size)
          i.keysAtom_.reportChanged();
        else
          for (var R = i.data_.keys(), re = o.keys(), fe = R.next(), $t = re.next(); !fe.done; ) {
            if (fe.value !== $t.value) {
              i.keysAtom_.reportChanged();
              break;
            }
            fe = R.next(), $t = re.next();
          }
      i.data_ = o;
    }), this;
  }, t.toString = function() {
    return "[object ObservableMap]";
  }, t.toJSON = function() {
    return Array.from(this);
  }, t.observe_ = function(n, i) {
    return process.env.NODE_ENV !== "production" && i === !0 && d("`observe` doesn't support fireImmediately=true in combination with maps."), $e(this, n);
  }, t.intercept_ = function(n) {
    return ke(this, n);
  }, Pe(e, [{
    key: "size",
    get: function() {
      return this.keysAtom_.reportObserved(), this.data_.size;
    }
  }, {
    key: Symbol.toStringTag,
    get: function() {
      return "Map";
    }
  }]);
}(), ue = /* @__PURE__ */ be("ObservableMap", nr);
function Zt(e) {
  return e[Symbol.toStringTag] = "MapIterator", Ht(e);
}
function ns(e) {
  if (Me(e) || ue(e))
    return e;
  if (Array.isArray(e))
    return new Map(e);
  if (S(e)) {
    var t = /* @__PURE__ */ new Map();
    for (var r in e)
      t.set(r, e[r]);
    return t;
  } else
    return d(21, e);
}
var rs = {}, rr = /* @__PURE__ */ function() {
  function e(r, n, i) {
    var s = this;
    n === void 0 && (n = pe), i === void 0 && (i = process.env.NODE_ENV !== "production" ? "ObservableSet@" + V() : "ObservableSet"), this.name_ = void 0, this[_] = rs, this.data_ = /* @__PURE__ */ new Set(), this.atom_ = void 0, this.changeListeners_ = void 0, this.interceptors_ = void 0, this.dehancer = void 0, this.enhancer_ = void 0, this.name_ = i, m(Set) || d(22), this.enhancer_ = function(o, a) {
      return n(o, a, i);
    }, ce(function() {
      s.atom_ = yn(s.name_), r && s.replace(r);
    });
  }
  var t = e.prototype;
  return t.dehanceValue_ = function(n) {
    return this.dehancer !== void 0 ? this.dehancer(n) : n;
  }, t.clear = function() {
    var n = this;
    ee(function() {
      jn(function() {
        for (var i = Ae(n.data_.values()), s; !(s = i()).done; ) {
          var o = s.value;
          n.delete(o);
        }
      });
    });
  }, t.forEach = function(n, i) {
    for (var s = Ae(this), o; !(o = s()).done; ) {
      var a = o.value;
      n.call(i, a, a, this);
    }
  }, t.add = function(n) {
    var i = this;
    if (X(this.atom_), G(this)) {
      var s = x(this, {
        type: se,
        object: this,
        newValue: n
      });
      if (!s)
        return this;
    }
    if (!this.has(n)) {
      ee(function() {
        i.data_.add(i.enhancer_(n, void 0)), i.atom_.reportChanged();
      });
      var o = process.env.NODE_ENV !== "production" && y(), a = K(this), u = a || o ? {
        observableKind: "set",
        debugObjectName: this.name_,
        type: se,
        object: this,
        newValue: n
      } : null;
      o && process.env.NODE_ENV !== "production" && M(u), a && F(this, u), o && process.env.NODE_ENV !== "production" && P();
    }
    return this;
  }, t.delete = function(n) {
    var i = this;
    if (G(this)) {
      var s = x(this, {
        type: nt,
        object: this,
        oldValue: n
      });
      if (!s)
        return !1;
    }
    if (this.has(n)) {
      var o = process.env.NODE_ENV !== "production" && y(), a = K(this), u = a || o ? {
        observableKind: "set",
        debugObjectName: this.name_,
        type: nt,
        object: this,
        oldValue: n
      } : null;
      return o && process.env.NODE_ENV !== "production" && M(u), ee(function() {
        i.atom_.reportChanged(), i.data_.delete(n);
      }), a && F(this, u), o && process.env.NODE_ENV !== "production" && P(), !0;
    }
    return !1;
  }, t.has = function(n) {
    return this.atom_.reportObserved(), this.data_.has(this.dehanceValue_(n));
  }, t.entries = function() {
    var n = 0, i = Array.from(this.keys()), s = Array.from(this.values());
    return Qt({
      next: function() {
        var a = n;
        return n += 1, a < s.length ? {
          value: [i[a], s[a]],
          done: !1
        } : {
          value: void 0,
          done: !0
        };
      }
    });
  }, t.keys = function() {
    return this.values();
  }, t.values = function() {
    this.atom_.reportObserved();
    var n = this, i = 0, s = Array.from(this.data_.values());
    return Qt({
      next: function() {
        return i < s.length ? {
          value: n.dehanceValue_(s[i++]),
          done: !1
        } : {
          value: void 0,
          done: !0
        };
      }
    });
  }, t.intersection = function(n) {
    if (Q(n) && !W(n))
      return n.intersection(this);
    var i = new Set(this);
    return i.intersection(n);
  }, t.union = function(n) {
    if (Q(n) && !W(n))
      return n.union(this);
    var i = new Set(this);
    return i.union(n);
  }, t.difference = function(n) {
    return new Set(this).difference(n);
  }, t.symmetricDifference = function(n) {
    if (Q(n) && !W(n))
      return n.symmetricDifference(this);
    var i = new Set(this);
    return i.symmetricDifference(n);
  }, t.isSubsetOf = function(n) {
    return new Set(this).isSubsetOf(n);
  }, t.isSupersetOf = function(n) {
    return new Set(this).isSupersetOf(n);
  }, t.isDisjointFrom = function(n) {
    if (Q(n) && !W(n))
      return n.isDisjointFrom(this);
    var i = new Set(this);
    return i.isDisjointFrom(n);
  }, t.replace = function(n) {
    var i = this;
    return W(n) && (n = new Set(n)), ee(function() {
      Array.isArray(n) ? (i.clear(), n.forEach(function(s) {
        return i.add(s);
      })) : Q(n) ? (i.clear(), n.forEach(function(s) {
        return i.add(s);
      })) : n != null && d("Cannot initialize set from " + n);
    }), this;
  }, t.observe_ = function(n, i) {
    return process.env.NODE_ENV !== "production" && i === !0 && d("`observe` doesn't support fireImmediately=true in combination with sets."), $e(this, n);
  }, t.intercept_ = function(n) {
    return ke(this, n);
  }, t.toJSON = function() {
    return Array.from(this);
  }, t.toString = function() {
    return "[object ObservableSet]";
  }, t[Symbol.iterator] = function() {
    return this.values();
  }, Pe(e, [{
    key: "size",
    get: function() {
      return this.atom_.reportObserved(), this.data_.size;
    }
  }, {
    key: Symbol.toStringTag,
    get: function() {
      return "Set";
    }
  }]);
}(), W = /* @__PURE__ */ be("ObservableSet", rr);
function Qt(e) {
  return e[Symbol.toStringTag] = "SetIterator", Ht(e);
}
var en = /* @__PURE__ */ Object.create(null), tn = "remove", Tt = /* @__PURE__ */ function() {
  function e(r, n, i, s) {
    n === void 0 && (n = /* @__PURE__ */ new Map()), s === void 0 && (s = Qr), this.target_ = void 0, this.values_ = void 0, this.name_ = void 0, this.defaultAnnotation_ = void 0, this.keysAtom_ = void 0, this.changeListeners_ = void 0, this.interceptors_ = void 0, this.proxy_ = void 0, this.isPlainObject_ = void 0, this.appliedAnnotations_ = void 0, this.pendingKeys_ = void 0, this.target_ = r, this.values_ = n, this.name_ = i, this.defaultAnnotation_ = s, this.keysAtom_ = new ae(process.env.NODE_ENV !== "production" ? this.name_ + ".keys" : "ObservableObject.keys"), this.isPlainObject_ = S(this.target_), process.env.NODE_ENV !== "production" && !ur(this.defaultAnnotation_) && d("defaultAnnotation must be valid annotation"), process.env.NODE_ENV !== "production" && (this.appliedAnnotations_ = {});
  }
  var t = e.prototype;
  return t.getObservablePropValue_ = function(n) {
    return this.values_.get(n).get();
  }, t.setObservablePropValue_ = function(n, i) {
    var s = this.values_.get(n);
    if (s instanceof k)
      return s.set(i), !0;
    if (G(this)) {
      var o = x(this, {
        type: $,
        object: this.proxy_ || this.target_,
        name: n,
        newValue: i
      });
      if (!o)
        return null;
      i = o.newValue;
    }
    if (i = s.prepareNewValue_(i), i !== l.UNCHANGED) {
      var a = K(this), u = process.env.NODE_ENV !== "production" && y(), c = a || u ? {
        type: $,
        observableKind: "object",
        debugObjectName: this.name_,
        object: this.proxy_ || this.target_,
        oldValue: s.value_,
        name: n,
        newValue: i
      } : null;
      process.env.NODE_ENV !== "production" && u && M(c), s.setNewValue_(i), a && F(this, c), process.env.NODE_ENV !== "production" && u && P();
    }
    return !0;
  }, t.get_ = function(n) {
    return l.trackingDerivation && !U(this.target_, n) && this.has_(n), this.target_[n];
  }, t.set_ = function(n, i, s) {
    return s === void 0 && (s = !1), U(this.target_, n) ? this.values_.has(n) ? this.setObservablePropValue_(n, i) : s ? Reflect.set(this.target_, n, i) : (this.target_[n] = i, !0) : this.extend_(n, {
      value: i,
      enumerable: !0,
      writable: !0,
      configurable: !0
    }, this.defaultAnnotation_, s);
  }, t.has_ = function(n) {
    if (!l.trackingDerivation)
      return n in this.target_;
    this.pendingKeys_ || (this.pendingKeys_ = /* @__PURE__ */ new Map());
    var i = this.pendingKeys_.get(n);
    return i || (i = new _e(n in this.target_, at, process.env.NODE_ENV !== "production" ? this.name_ + "." + gt(n) + "?" : "ObservableObject.key?", !1), this.pendingKeys_.set(n, i)), i.get();
  }, t.make_ = function(n, i) {
    if (i === !0 && (i = this.defaultAnnotation_), i !== !1) {
      if (sn(this, i, n), !(n in this.target_)) {
        var s;
        if ((s = this.target_[N]) != null && s[n])
          return;
        d(1, i.annotationType_, this.name_ + "." + n.toString());
      }
      for (var o = this.target_; o && o !== it; ) {
        var a = Xe(o, n);
        if (a) {
          var u = i.make_(this, n, a, o);
          if (u === 0)
            return;
          if (u === 1)
            break;
        }
        o = Object.getPrototypeOf(o);
      }
      rn(this, i, n);
    }
  }, t.extend_ = function(n, i, s, o) {
    if (o === void 0 && (o = !1), s === !0 && (s = this.defaultAnnotation_), s === !1)
      return this.defineProperty_(n, i, o);
    sn(this, s, n);
    var a = s.extend_(this, n, i, o);
    return a && rn(this, s, n), a;
  }, t.defineProperty_ = function(n, i, s) {
    s === void 0 && (s = !1), X(this.keysAtom_);
    try {
      I();
      var o = this.delete_(n);
      if (!o)
        return o;
      if (G(this)) {
        var a = x(this, {
          object: this.proxy_ || this.target_,
          name: n,
          type: se,
          newValue: i.value
        });
        if (!a)
          return null;
        var u = a.newValue;
        i.value !== u && (i = Z({}, i, {
          value: u
        }));
      }
      if (s) {
        if (!Reflect.defineProperty(this.target_, n, i))
          return !1;
      } else
        Y(this.target_, n, i);
      this.notifyPropertyAddition_(n, i.value);
    } finally {
      B();
    }
    return !0;
  }, t.defineObservableProperty_ = function(n, i, s, o) {
    o === void 0 && (o = !1), X(this.keysAtom_);
    try {
      I();
      var a = this.delete_(n);
      if (!a)
        return a;
      if (G(this)) {
        var u = x(this, {
          object: this.proxy_ || this.target_,
          name: n,
          type: se,
          newValue: i
        });
        if (!u)
          return null;
        i = u.newValue;
      }
      var c = nn(n), f = {
        configurable: l.safeDescriptors ? this.isPlainObject_ : !0,
        enumerable: !0,
        get: c.get,
        set: c.set
      };
      if (o) {
        if (!Reflect.defineProperty(this.target_, n, f))
          return !1;
      } else
        Y(this.target_, n, f);
      var p = new _e(i, s, process.env.NODE_ENV !== "production" ? this.name_ + "." + n.toString() : "ObservableObject.key", !1);
      this.values_.set(n, p), this.notifyPropertyAddition_(n, p.value_);
    } finally {
      B();
    }
    return !0;
  }, t.defineComputedProperty_ = function(n, i, s) {
    s === void 0 && (s = !1), X(this.keysAtom_);
    try {
      I();
      var o = this.delete_(n);
      if (!o)
        return o;
      if (G(this)) {
        var a = x(this, {
          object: this.proxy_ || this.target_,
          name: n,
          type: se,
          newValue: void 0
        });
        if (!a)
          return null;
      }
      i.name || (i.name = process.env.NODE_ENV !== "production" ? this.name_ + "." + n.toString() : "ObservableObject.key"), i.context = this.proxy_ || this.target_;
      var u = nn(n), c = {
        configurable: l.safeDescriptors ? this.isPlainObject_ : !0,
        enumerable: !1,
        get: u.get,
        set: u.set
      };
      if (s) {
        if (!Reflect.defineProperty(this.target_, n, c))
          return !1;
      } else
        Y(this.target_, n, c);
      this.values_.set(n, new k(i)), this.notifyPropertyAddition_(n, void 0);
    } finally {
      B();
    }
    return !0;
  }, t.delete_ = function(n, i) {
    if (i === void 0 && (i = !1), X(this.keysAtom_), !U(this.target_, n))
      return !0;
    if (G(this)) {
      var s = x(this, {
        object: this.proxy_ || this.target_,
        name: n,
        type: tn
      });
      if (!s)
        return null;
    }
    try {
      var o;
      I();
      var a = K(this), u = process.env.NODE_ENV !== "production" && y(), c = this.values_.get(n), f = void 0;
      if (!c && (a || u)) {
        var p;
        f = (p = Xe(this.target_, n)) == null ? void 0 : p.value;
      }
      if (i) {
        if (!Reflect.deleteProperty(this.target_, n))
          return !1;
      } else
        delete this.target_[n];
      if (process.env.NODE_ENV !== "production" && delete this.appliedAnnotations_[n], c && (this.values_.delete(n), c instanceof _e && (f = c.value_), Bn(c)), this.keysAtom_.reportChanged(), (o = this.pendingKeys_) == null || (o = o.get(n)) == null || o.set(n in this.target_), a || u) {
        var v = {
          type: tn,
          observableKind: "object",
          object: this.proxy_ || this.target_,
          debugObjectName: this.name_,
          oldValue: f,
          name: n
        };
        process.env.NODE_ENV !== "production" && u && M(v), a && F(this, v), process.env.NODE_ENV !== "production" && u && P();
      }
    } finally {
      B();
    }
    return !0;
  }, t.observe_ = function(n, i) {
    return process.env.NODE_ENV !== "production" && i === !0 && d("`observe` doesn't support the fire immediately property for observable objects."), $e(this, n);
  }, t.intercept_ = function(n) {
    return ke(this, n);
  }, t.notifyPropertyAddition_ = function(n, i) {
    var s, o = K(this), a = process.env.NODE_ENV !== "production" && y();
    if (o || a) {
      var u = o || a ? {
        type: se,
        observableKind: "object",
        debugObjectName: this.name_,
        object: this.proxy_ || this.target_,
        name: n,
        newValue: i
      } : null;
      process.env.NODE_ENV !== "production" && a && M(u), o && F(this, u), process.env.NODE_ENV !== "production" && a && P();
    }
    (s = this.pendingKeys_) == null || (s = s.get(n)) == null || s.set(!0), this.keysAtom_.reportChanged();
  }, t.ownKeys_ = function() {
    return this.keysAtom_.reportObserved(), Se(this.target_);
  }, t.keys_ = function() {
    return this.keysAtom_.reportObserved(), Object.keys(this.target_);
  }, e;
}();
function Oe(e, t) {
  var r;
  if (process.env.NODE_ENV !== "production" && t && me(e) && d("Options can't be provided for already observable objects."), U(e, _))
    return process.env.NODE_ENV !== "production" && !(ar(e) instanceof Tt) && d("Cannot convert '" + rt(e) + `' into observable object:
The target is already observable of different type.
Extending builtins is not supported.`), e;
  process.env.NODE_ENV !== "production" && !Object.isExtensible(e) && d("Cannot make the designated object observable; it is not extensible");
  var n = (r = t == null ? void 0 : t.name) != null ? r : process.env.NODE_ENV !== "production" ? (S(e) ? "ObservableObject" : e.constructor.name) + "@" + V() : "ObservableObject", i = new Tt(e, /* @__PURE__ */ new Map(), String(n), li(t));
  return Ie(e, _, i), e;
}
var is = /* @__PURE__ */ be("ObservableObjectAdministration", Tt);
function nn(e) {
  return en[e] || (en[e] = {
    get: function() {
      return this[_].getObservablePropValue_(e);
    },
    set: function(r) {
      return this[_].setObservablePropValue_(e, r);
    }
  });
}
function me(e) {
  return st(e) ? is(e[_]) : !1;
}
function rn(e, t, r) {
  var n;
  process.env.NODE_ENV !== "production" && (e.appliedAnnotations_[r] = t), (n = e.target_[N]) == null || delete n[r];
}
function sn(e, t, r) {
  if (process.env.NODE_ENV !== "production" && !ur(t) && d("Cannot annotate '" + e.name_ + "." + r.toString() + "': Invalid annotation."), process.env.NODE_ENV !== "production" && !Je(t) && U(e.appliedAnnotations_, r)) {
    var n = e.name_ + "." + r.toString(), i = e.appliedAnnotations_[r].annotationType_, s = t.annotationType_;
    d("Cannot apply '" + s + "' to '" + n + "':" + (`
The field is already annotated with '` + i + "'.") + `
Re-annotating fields is not allowed.
Use 'override' annotation for methods overridden by subclass.`);
  }
}
var ss = /* @__PURE__ */ sr(0), os = /* @__PURE__ */ function() {
  var e = !1, t = {};
  return Object.defineProperty(t, "0", {
    set: function() {
      e = !0;
    }
  }), Object.create(t)[0] = 1, e === !1;
}(), bt = 0, ir = function() {
};
function as(e, t) {
  Object.setPrototypeOf ? Object.setPrototypeOf(e.prototype, t) : e.prototype.__proto__ !== void 0 ? e.prototype.__proto__ = t : e.prototype = t;
}
as(ir, Array.prototype);
var Bt = /* @__PURE__ */ function(e) {
  function t(n, i, s, o) {
    var a;
    return s === void 0 && (s = process.env.NODE_ENV !== "production" ? "ObservableArray@" + V() : "ObservableArray"), o === void 0 && (o = !1), a = e.call(this) || this, ce(function() {
      var u = new It(s, i, o, !0);
      u.proxy_ = a, gn(a, _, u), n && n.length && a.spliceWithArray(0, 0, n), os && Object.defineProperty(a, "0", ss);
    }), a;
  }
  En(t, e);
  var r = t.prototype;
  return r.concat = function() {
    this[_].atom_.reportObserved();
    for (var i = arguments.length, s = new Array(i), o = 0; o < i; o++)
      s[o] = arguments[o];
    return Array.prototype.concat.apply(
      this.slice(),
      //@ts-ignore
      s.map(function(a) {
        return Fe(a) ? a.slice() : a;
      })
    );
  }, r[Symbol.iterator] = function() {
    var n = this, i = 0;
    return Ht({
      next: function() {
        return i < n.length ? {
          value: n[i++],
          done: !1
        } : {
          done: !0,
          value: void 0
        };
      }
    });
  }, Pe(t, [{
    key: "length",
    get: function() {
      return this[_].getArrayLength_();
    },
    set: function(i) {
      this[_].setArrayLength_(i);
    }
  }, {
    key: Symbol.toStringTag,
    get: function() {
      return "Array";
    }
  }]);
}(ir);
Object.entries(tt).forEach(function(e) {
  var t = e[0], r = e[1];
  t !== "concat" && Ie(Bt.prototype, t, r);
});
function sr(e) {
  return {
    enumerable: !1,
    configurable: !0,
    get: function() {
      return this[_].get_(e);
    },
    set: function(r) {
      this[_].set_(e, r);
    }
  };
}
function us(e) {
  Y(Bt.prototype, "" + e, sr(e));
}
function or(e) {
  if (e > bt) {
    for (var t = bt; t < e + 100; t++)
      us(t);
    bt = e;
  }
}
or(1e3);
function cs(e, t, r) {
  return new Bt(e, t, r);
}
function De(e, t) {
  if (typeof e == "object" && e !== null) {
    if (Fe(e))
      return t !== void 0 && d(23), e[_].atom_;
    if (W(e))
      return e.atom_;
    if (ue(e)) {
      if (t === void 0)
        return e.keysAtom_;
      var r = e.data_.get(t) || e.hasMap_.get(t);
      return r || d(25, t, rt(e)), r;
    }
    if (me(e)) {
      if (!t)
        return d(26);
      var n = e[_].values_.get(t);
      return n || d(27, t, rt(e)), n;
    }
    if (jt(e) || dt(e) || et(e))
      return e;
  } else if (m(e) && et(e[_]))
    return e[_];
  d(28);
}
function ar(e, t) {
  if (e || d(29), jt(e) || dt(e) || et(e) || ue(e) || W(e))
    return e;
  if (e[_])
    return e[_];
  d(24, e);
}
function rt(e, t) {
  var r;
  if (t !== void 0)
    r = De(e, t);
  else {
    if (Le(e))
      return e.name;
    me(e) || ue(e) || W(e) ? r = ar(e) : r = De(e);
  }
  return r.name_;
}
function ce(e) {
  var t = ge(), r = lt(!0);
  I();
  try {
    return e();
  } finally {
    B(), ft(r), te(t);
  }
}
var on = it.toString;
function Ut(e, t, r) {
  return r === void 0 && (r = -1), Lt(e, t, r);
}
function Lt(e, t, r, n, i) {
  if (e === t)
    return e !== 0 || 1 / e === 1 / t;
  if (e == null || t == null)
    return !1;
  if (e !== e)
    return t !== t;
  var s = typeof e;
  if (s !== "function" && s !== "object" && typeof t != "object")
    return !1;
  var o = on.call(e);
  if (o !== on.call(t))
    return !1;
  switch (o) {
    // Strings, numbers, regular expressions, dates, and booleans are compared by value.
    case "[object RegExp]":
    // RegExps are coerced to strings for comparison (Note: '' + /a/i === '/a/i')
    case "[object String]":
      return "" + e == "" + t;
    case "[object Number]":
      return +e != +e ? +t != +t : +e == 0 ? 1 / +e === 1 / t : +e == +t;
    case "[object Date]":
    case "[object Boolean]":
      return +e == +t;
    case "[object Symbol]":
      return typeof Symbol < "u" && Symbol.valueOf.call(e) === Symbol.valueOf.call(t);
    case "[object Map]":
    case "[object Set]":
      r >= 0 && r++;
      break;
  }
  e = an(e), t = an(t);
  var a = o === "[object Array]";
  if (!a) {
    if (typeof e != "object" || typeof t != "object")
      return !1;
    var u = e.constructor, c = t.constructor;
    if (u !== c && !(m(u) && u instanceof u && m(c) && c instanceof c) && "constructor" in e && "constructor" in t)
      return !1;
  }
  if (r === 0)
    return !1;
  r < 0 && (r = -1), n = n || [], i = i || [];
  for (var f = n.length; f--; )
    if (n[f] === e)
      return i[f] === t;
  if (n.push(e), i.push(t), a) {
    if (f = e.length, f !== t.length)
      return !1;
    for (; f--; )
      if (!Lt(e[f], t[f], r - 1, n, i))
        return !1;
  } else {
    var p = Object.keys(e), v;
    if (f = p.length, Object.keys(t).length !== f)
      return !1;
    for (; f--; )
      if (v = p[f], !(U(t, v) && Lt(e[v], t[v], r - 1, n, i)))
        return !1;
  }
  return n.pop(), i.pop(), !0;
}
function an(e) {
  return Fe(e) ? e.slice() : Me(e) || ue(e) || Q(e) || W(e) ? Array.from(e.entries()) : e;
}
var un, ls = ((un = Mt().Iterator) == null ? void 0 : un.prototype) || {};
function Ht(e) {
  return e[Symbol.iterator] = fs, Object.assign(Object.create(ls), e);
}
function fs() {
  return this;
}
function ur(e) {
  return (
    // Can be function
    e instanceof Object && typeof e.annotationType_ == "string" && m(e.make_) && m(e.extend_)
  );
}
["Symbol", "Map", "Set"].forEach(function(e) {
  var t = Mt();
  typeof t[e] > "u" && d("MobX requires global '" + e + "' to be available or polyfilled");
});
typeof __MOBX_DEVTOOLS_GLOBAL_HOOK__ == "object" && __MOBX_DEVTOOLS_GLOBAL_HOOK__.injectMobx({
  spy: wi,
  extras: {
    getDebugName: rt
  },
  $mobx: _
});
var cr = /* @__PURE__ */ ((e) => (e.Free = "Free", e.Day_Pass = "Day_Pass", e))(cr || {});
class kt {
  /**
   * Creates a new instance of the PlayerModel class.
   * @param screenName - The screen name of the player.
   */
  constructor(t, r) {
    h(this, "screenName");
    /** String ID connecting the player to their connection */
    h(this, "connectionId");
    h(this, "image", null);
    /** For when your controller is ready to play the game */
    h(this, "ready", !1);
    /** True is the user is actively playing and not disconnected */
    h(this, "active", !0);
    /** True if the player has a connection */
    h(this, "hasConnection", !0);
    h(this, "isHost", !1);
    h(this, "subscription", cr.Free);
    Ke(this, {}, { autoBind: !0 }), this.screenName = t, this.connectionId = r;
  }
  static fromDto(t) {
    const r = new kt(t.screenName, t.connectionId);
    return r.image = t.image, r.ready = t.ready, r.active = t.active, r.hasConnection = t.hasConnection, r.isHost = t.isHost, r.subscription = t.subscription, r;
  }
  async waitForReady(t) {
    return qi(() => this.ready, {
      name: `Wait for ${this.connectionId}|${this.screenName} to be ready`,
      signal: t
    });
  }
  get dto() {
    return {
      screenName: this.screenName,
      connectionId: this.connectionId,
      image: this.image,
      ready: this.ready,
      active: this.active,
      hasConnection: this.hasConnection,
      isHost: this.isHost,
      subscription: this.subscription
    };
  }
}
const Rt = 1e3, wt = 60 * Rt, Dt = 60 * wt, cn = 24 * Dt;
class z {
  /**
   * Creates a new Time instance.
   * @param timeInMilliseconds The time duration in milliseconds.
   */
  constructor(t) {
    this.timeInMilliseconds = t;
  }
  /**
   * Converts the time duration to milliseconds.
   * @returns The time duration in milliseconds.
   */
  toMilliseconds() {
    return this.timeInMilliseconds;
  }
  /**
   * Converts the time duration to seconds.
   * @returns The time duration in seconds.
   */
  toSeconds() {
    return this.timeInMilliseconds / Rt;
  }
  /**
   * Converts the time duration to minutes.
   * @returns The time duration in minutes.
   */
  toMinutes() {
    return this.timeInMilliseconds / wt;
  }
  /**
   * Converts the time duration to hours.
   * @returns The time duration in hours.
   */
  toHours() {
    return this.timeInMilliseconds / Dt;
  }
  /**
   * Converts the time duration to days.
   * @returns The time duration in days.
   */
  toDays() {
    return this.timeInMilliseconds / cn;
  }
  /**
   * Adds another Time instance to the current time duration.
   * @param time The Time instance to add.
   * @returns A new Time instance representing the sum of the two time durations.
   */
  add(t) {
    return new z(this.timeInMilliseconds + t.toMilliseconds());
  }
  /**
   * Subtracts another Time instance from the current time duration.
   * @param time The Time instance to subtract.
   * @returns A new Time instance representing the difference between the two time durations.
   */
  sub(t) {
    return new z(this.timeInMilliseconds - t.toMilliseconds());
  }
  /**
   * Multiplies the time duration by a factor.
   * @param factor The factor to multiply by.
   * @returns A new Time instance representing the multiplied time duration.
   */
  multiply(t) {
    return new z(this.timeInMilliseconds * t);
  }
  /**
   * Divides the time duration by a divisor.
   * @param divisor The divisor to divide by.
   * @returns A new Time instance representing the divided time duration.
   */
  divide(t) {
    return new z(this.timeInMilliseconds / t);
  }
  /**
   * Checks if the current time duration is equal to another Time instance.
   * @param time The Time instance to compare.
   * @returns True if the time durations are equal, false otherwise.
   */
  isEqual(t) {
    return this.timeInMilliseconds === t.toMilliseconds();
  }
  /**
   * Checks if the current time duration is greater than another Time instance.
   * @param time The Time instance to compare.
   * @returns True if the current time duration is greater, false otherwise.
   */
  isGreaterThan(t) {
    return this.timeInMilliseconds > t.toMilliseconds();
  }
  /**
   * Checks if the current time duration is greater than or equal to another Time instance.
   * @param time The Time instance to compare.
   * @returns True if the current time duration is greater than or equal, false otherwise.
   */
  isGreaterThanOrEqual(t) {
    return this.timeInMilliseconds >= t.toMilliseconds();
  }
  /**
   * Checks if the current time duration is less than another Time instance.
   * @param time The Time instance to compare.
   * @returns True if the current time duration is less, false otherwise.
   */
  isLessThan(t) {
    return this.timeInMilliseconds < t.toMilliseconds();
  }
  /**
   * Checks if the current time duration is less than or equal to another Time instance.
   * @param time The Time instance to compare.
   * @returns True if the current time duration is less than or equal, false otherwise.
   */
  isLessThanOrEqual(t) {
    return this.timeInMilliseconds <= t.toMilliseconds();
  }
  /**
   * Creates a new Time instance from a duration in milliseconds.
   * @param timeInMilliseconds The time duration in milliseconds.
   * @returns A new Time instance representing the given duration.
   */
  static fromMilliseconds(t) {
    return new z(t);
  }
  /**
   * Creates a new Time instance from a duration in seconds.
   * @param timeInSeconds The time duration in seconds.
   * @returns A new Time instance representing the given duration.
   */
  static fromSeconds(t) {
    return new z(t * Rt);
  }
  /**
   * Creates a new Time instance from a duration in minutes.
   * @param timeInMinutes The time duration in minutes.
   * @returns A new Time instance representing the given duration.
   */
  static fromMinutes(t) {
    return new z(t * wt);
  }
  /**
   * Creates a new Time instance from a duration in hours.
   * @param timeInHours The time duration in hours.
   * @returns A new Time instance representing the given duration.
   */
  static fromHours(t) {
    return new z(t * Dt);
  }
  /**
   * Creates a new Time instance from a duration in days.
   * @param timeInDays The time duration in days.
   * @returns A new Time instance representing the given duration.
   */
  static fromDays(t) {
    return new z(t * cn);
  }
}
function Os(e) {
  return typeof e == "number" ? e : e.toMilliseconds();
}
function ms(e) {
  return typeof e == "number" ? e / 1e3 : e.toSeconds();
}
const ln = Symbol("annotationsSymbol"), fn = Object.prototype;
function lr(e, t, r) {
  if (we(e))
    throw new Error("Target must not be observable");
  let n = e[ln];
  if (!n) {
    n = {};
    let i = e;
    for (; i && i !== fn; )
      Reflect.ownKeys(i).forEach((o) => {
        o === _ || o === "constructor" || (n[o] = t && o in t ? (
          // eslint-disable-next-line @typescript-eslint/no-explicit-any
          t[o]
        ) : !0);
      }), i = Object.getPrototypeOf(i);
    const s = Object.getPrototypeOf(e);
    s && s !== fn && Object.defineProperty(s, ln, { value: n });
  }
  return Yi(e, n, r);
}
function dn(e) {
  return e && typeof e == "object" && !Array.isArray(e);
}
const Ne = ie((e, t) => {
  for (const r of Object.keys(t)) {
    const n = e[r], i = t[r];
    dn(n) && dn(i) ? me(n) ? Ne(n, i) : e[r] = i : Fe(n) && Array.isArray(i) ? n.replace(i) : n !== i && (e[r] = i);
  }
  return e;
});
class ds {
  constructor(t) {
    /** global settings, null value until loaded */
    h(this, "globalSettings", null);
    /** game storage, null value until loaded */
    h(this, "gameStorage", null);
    this.controllerCommunicator = t, Ke(this, {}, { autoBind: !0 });
  }
  setGlobalSetting(t, r) {
    this.controllerCommunicator.sendAppMessage({
      type: b.SET_GLOBAL_SETTING_CONTROLLER_G2P,
      // eslint-disable-next-line @typescript-eslint/no-explicit-any -- this is safe
      data: { key: t, value: r }
    });
    const { promise: n, resolve: i } = Promise.withResolvers(), s = this.controllerCommunicator.addAppMessageListener((o) => {
      o.type === b.UPDATED_GLOBAL_SETTING_CONTROLLER_P2G && o.data.key === t && (i(), s.destroy());
    });
    return n;
  }
  setGameStorage(t, r) {
    this.controllerCommunicator.sendAppMessage({
      type: b.SET_GAME_STORAGE_CONTROLLER_G2P,
      data: { key: t, value: r }
    });
    const { promise: n, resolve: i } = Promise.withResolvers(), s = this.controllerCommunicator.addAppMessageListener((o) => {
      o.type === b.UPDATED_GAME_STORAGE_CONTROLLER_P2G && o.data.key === t && (i(), s.destroy());
    });
    return n;
  }
}
class Es extends hn {
  /**
   * @param {boolean} autoReady - Indicates whether the controller should automatically become ready. (Wait 1 second before becoming ready)
   */
  constructor(r = !1) {
    super();
    h(this, "player", null);
    h(this, "dataPersistence", new ds(this));
    /** This should not be used unless you know what you are doing */
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    h(this, "messageListener");
    /** Do not change this value directly, use ready and unready functions */
    h(this, "isReady", !1);
    h(this, "lobbyGame");
    h(this, "devMode");
    h(this, "hosterReady", !1);
    h(this, "joinCode");
    h(this, "joinUrl");
    /** Current ping (time from hoster to controller and controller to hoster combined) */
    h(this, "pingData", null);
    h(this, "pingListeners", []);
    /** Promise indicating when communication between tp.games and the game have had first communication */
    h(this, "waitForLoad");
    /** If this value is true, tp.games and the game have communicated */
    h(this, "hasLoaded", !1);
    const { promise: n, resolve: i } = Promise.withResolvers();
    this.waitForLoad = n, this.messageListener = (s) => this.messageHandler(s.data), window.addEventListener("message", this.messageListener), this.addAppMessageListener(({ data: s }) => {
      i(), this.hasLoaded = !0, this.hosterReady = s.hosterReady, this.lobbyGame = s.lobbyGame, this.devMode = s.devMode, this.joinCode = s.joinCode, this.joinUrl = s.joinUrl, this.connectionId = s.connectionId, !this.dataPersistence.globalSettings || !s.globalSettings ? this.dataPersistence.globalSettings = s.globalSettings : Ne(this.dataPersistence.globalSettings, s.globalSettings), !this.dataPersistence.gameStorage || !s.gameStorage ? this.dataPersistence.gameStorage = s.gameStorage : Ne(this.dataPersistence.gameStorage, s.gameStorage), !this.player || !s.player ? this.player = s.player : Ne(this.player, s.player);
    }, b.AppData_CONTROLLER), this.sendAppMessage({
      type: b.INIT_GAME_CONTROLLER,
      data: {
        coreVersion: "0.2.17"
      }
    }), this.setupPingPong(), r && setTimeout(() => {
      this.ready();
    }, 1e3), lr(this, {}, { autoBind: !0 });
  }
  addHosterReadyListener(r) {
    return this.addAppMessageListener(({ data: n }) => {
      r(n.hosterReady);
    }, b.AppData_CONTROLLER);
  }
  /**
   * Removes the event listener for incoming messages.
   * Use this when you are done with the controller.
   */
  destructor() {
    window.removeEventListener("message", this.messageListener);
  }
  setupPingPong() {
    this.addAppMessageListener(({ data: r }) => {
      this.sendAppMessage({
        type: b.PONG_CONTROLLER,
        data: {
          id: r.id,
          controllerTime: Date.now(),
          playerId: r.playerId
        }
      });
    }, b.PING_HOSTER), this.addAppMessageListener(({ data: r }) => {
      const n = {
        ping: r.pingMs,
        lastPoll: Date.now(),
        timeSinceStart: r.timeSinceStart,
        timeSinceStartPingAdjusted: r.timeSinceStart + r.pingMs / 2
      };
      this.pingData = n, this.pingListeners.forEach((i) => i.listener(n));
    }, b.PONG_HOSTER);
  }
  /**
   * Sets the ready status of the controller.
   */
  ready() {
    this.isReady = !0, this.sendAppMessage({
      type: b.READY_STATUS_CONTROLLER,
      data: {
        ready: !0
      }
    });
  }
  /**
   * Sets the controller to an unready state. Note: this should never have to happen
   */
  unready() {
    this.isReady = !1, this.sendAppMessage({
      type: b.READY_STATUS_CONTROLLER,
      data: {
        ready: !1
      }
    });
  }
  /**
   * Sends a game message to the hoster.
   * @param data The game data to be sent.
   */
  sendGameMessage(r) {
    this.sendMessage({
      type: b.GAME_ACTION_CONTROLLER,
      data: {
        payload: r
      }
    });
  }
  /**
   * Adds a game message listener to the controller communicator.
   * The listener will be called whenever a game action response is received.
   * @param listener - The callback function to be called when a game action response is received.
   * @returns An object with a `destroy` method that can be used to remove the listener.
   */
  addGameMessageListener(r) {
    const n = {
      listener: (i) => {
        i.type === b.GAME_ACTION_RESPONSE_CONTROLLER && r(i.data);
      }
    };
    return this.gameMessageListeners.push(n), {
      destroy: () => {
        const i = this.gameMessageListeners.indexOf(n);
        i !== -1 && this.gameMessageListeners.splice(i, 1);
      }
    };
  }
  addPingListener(r) {
    return this.pingListeners.push({ listener: r }), {
      destroy: () => {
        const n = this.pingListeners.findIndex(
          (i) => i.listener === r
        );
        n !== -1 && this.pingListeners.splice(n, 1);
      }
    };
  }
  endGame() {
    this.sendAppMessage({ type: b.END_GAME_CONTROLLER, data: {} });
  }
  reloadGame() {
    this.sendAppMessage({ type: b.RELOAD_GAME_CONTROLLER, data: {} });
  }
  /** This should not be used unless you know what you are doing */
  messageHandler(r) {
    if (super.messageHandler(r), r.type === b.GAME_ACTION_RESPONSE_CONTROLLER) {
      this.gameMessageListeners.forEach((n) => n.listener(r));
      return;
    }
  }
}
var _s = /* @__PURE__ */ ((e) => (e.Everyone = "Everyone", e.Teen = "Teen", e.Mature = "Mature", e))(_s || {});
class hs {
  constructor(t) {
    /** global settings, null value until loaded */
    h(this, "globalSettings", null);
    /** game storage, null value until loaded */
    h(this, "gameStorage", null);
    this.hosterCommunicator = t, Ke(this, {}, { autoBind: !0 });
  }
  setGlobalSetting(t, r) {
    this.hosterCommunicator.sendAppMessage({
      type: b.SET_GLOBAL_SETTING_HOSTER_G2P,
      // eslint-disable-next-line @typescript-eslint/no-explicit-any -- this is safe
      data: { key: t, value: r }
    });
    const { promise: n, resolve: i } = Promise.withResolvers(), s = this.hosterCommunicator.addAppMessageListener((o) => {
      o.type === b.UPDATED_GLOBAL_SETTING_HOSTER_P2G && o.data.key === t && (i(), s.destroy());
    });
    return n;
  }
  setGameStorage(t, r) {
    this.hosterCommunicator.sendAppMessage({
      type: b.SET_GAME_STORAGE_HOSTER_G2P,
      data: { key: t, value: r }
    });
    const { promise: n, resolve: i } = Promise.withResolvers(), s = this.hosterCommunicator.addAppMessageListener((o) => {
      o.type === b.UPDATED_GAME_STORAGE_HOSTER_P2G && o.data.key === t && (i(), s.destroy());
    });
    return n;
  }
}
class _n {
  constructor() {
    h(this, "listeners", []);
  }
  addListener(t) {
    return this.listeners.push(t), {
      destroy: () => {
        this.listeners = this.listeners.filter((r) => r !== t);
      }
    };
  }
  emit(t) {
    this.listeners.forEach((r) => r(t));
  }
}
class ps {
  constructor(t, r) {
    h(this, "destructors", []);
    this.hosterCommunicator = t, this.playerModel = r, Ke(this, {}, { autoBind: !0 });
  }
  get screenName() {
    return this.playerModel.screenName;
  }
  get connectionId() {
    return this.playerModel.connectionId;
  }
  get image() {
    return this.playerModel.image;
  }
  get ready() {
    return this.playerModel.ready;
  }
  get active() {
    return this.playerModel.active;
  }
  get hasConnection() {
    return this.playerModel.hasConnection;
  }
  get isHost() {
    return this.playerModel.isHost;
  }
  get subscription() {
    return this.playerModel.subscription;
  }
  get dto() {
    return this.playerModel.dto;
  }
  sendMessage(t) {
    return this.hosterCommunicator.sendGameMessage(t, this.connectionId);
  }
  async waitForReady(t) {
    return this.playerModel.waitForReady(t);
  }
  addListenerHelper(t, r) {
    const n = Wn(t, vs(r));
    return this.destructors.push(n), n;
  }
  destroy() {
    this.destructors.forEach((t) => t());
  }
  addReadyListener(t) {
    return this.addListenerHelper(() => this.ready, t);
  }
  addActiveListener(t) {
    return this.addListenerHelper(() => this.active, t);
  }
  addConnectionListener(t) {
    return this.addListenerHelper(() => this.hasConnection, t);
  }
  addHostListener(t) {
    return this.addListenerHelper(() => this.isHost, t);
  }
  addScreenNameListener(t) {
    return this.addListenerHelper(() => this.screenName, t);
  }
  addImageListener(t) {
    return this.addListenerHelper(() => this.image, t);
  }
}
function vs(e) {
  return (t, r) => {
    t !== r && e(t);
  };
}
class bs {
  constructor(t) {
    h(this, "playerMap", /* @__PURE__ */ new Map());
    h(this, "playerToKick", /* @__PURE__ */ new Map());
    h(this, "joinEmitter", new _n());
    h(this, "kickedEmitter", new _n());
    this.hosterCommunicator = t, Ke(this, {}, { autoBind: !0 }), Wn(
      () => Array.from(this.playerMap.keys()),
      (r, n) => {
        const i = r.filter(
          (o) => !n.includes(o)
        ), s = n.filter(
          (o) => !r.includes(o)
        );
        i.forEach((o) => {
          const a = this.playerMap.get(o);
          a && this.joinEmitter.emit(a);
        }), s.forEach((o) => {
          const a = this.playerToKick.get(o);
          a && (this.kickedEmitter.emit(a), this.playerToKick.delete(o));
        });
      }
    );
  }
  get players() {
    return Array.from(this.playerMap.values());
  }
  smartUpdatePlayers(t) {
    const r = new Set(t.map((n) => n.connectionId));
    t.forEach((n) => {
      const i = this.playerMap.get(n.connectionId);
      if (i) {
        const s = i.playerModel;
        s.active = n.active, s.image = n.image, s.isHost = n.isHost, s.ready = n.ready, s.screenName = n.screenName, s.subscription = n.subscription, s.hasConnection = n.hasConnection;
      } else {
        const s = kt.fromDto(n);
        this.playerMap.set(
          n.connectionId,
          new ps(this.hosterCommunicator, s)
        );
      }
    }), this.playerMap.forEach((n, i) => {
      if (!r.has(i)) {
        const s = this.playerMap.get(i);
        if (!s) return;
        this.playerMap.delete(i), this.playerToKick.set(i, s);
      }
    });
  }
  addPlayerJoinListener(t) {
    return this.joinEmitter.addListener(t);
  }
  addPlayerKickedListener(t) {
    return this.kickedEmitter.addListener(t);
  }
  addPlayerReadyListener(t) {
    return this.addPlayerEventListener(
      (r, n) => r.addReadyListener(n),
      t
    );
  }
  addPlayerActiveListener(t) {
    return this.addPlayerEventListener(
      (r, n) => r.addActiveListener(n),
      t
    );
  }
  addPlayerHostListener(t) {
    return this.addPlayerEventListener(
      (r, n) => r.addHostListener(n),
      t
    );
  }
  addPlayerConnectionListener(t) {
    return this.addPlayerEventListener(
      (r, n) => r.addConnectionListener(n),
      t
    );
  }
  addPlayerImageListener(t) {
    return this.addPlayerEventListener(
      (r, n) => r.addImageListener(n),
      t
    );
  }
  addPlayerScreenNameListener(t) {
    return this.addPlayerEventListener(
      (r, n) => r.addScreenNameListener(n),
      t
    );
  }
  addPlayerEventListener(t, r) {
    const n = /* @__PURE__ */ new Map();
    for (const o of this.players) {
      const a = t(
        o,
        (u) => r(o, u)
      );
      n.set(o, a);
    }
    const i = this.addPlayerJoinListener((o) => {
      const a = t(
        o,
        (u) => r(o, u)
      );
      n.set(o, a);
    }), s = this.addPlayerKickedListener((o) => {
      const a = n.get(o);
      a && (a(), n.delete(o));
    });
    return {
      destroy: () => {
        i.destroy(), s.destroy(), n.forEach((o) => o());
      }
    };
  }
}
class ys extends hn {
  /**
   * @param {boolean} autoReady - Indicates whether the controller should automatically become ready. (Wait 1 second before becoming ready)
   */
  constructor(r = !1) {
    super();
    h(this, "playerStore", new bs(this));
    h(this, "dataPersistence", new hs(this));
    h(this, "playerPingMap", /* @__PURE__ */ new Map());
    h(this, "playerPingListeners", []);
    h(this, "startTime", Date.now());
    /** Don't write to this */
    h(this, "isReady", !1);
    /** Don't write to this */
    h(this, "lobbyGame");
    /** Don't write to this */
    h(this, "devMode");
    /** Don't write to this */
    h(this, "joinCode");
    /** Don't write to this */
    h(this, "joinUrl");
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    h(this, "messageListener");
    /** Promise indicating when communication between tp.games and the game have had first communication */
    h(this, "waitForLoad");
    /** If this value is true, tp.games and the game have communicated */
    h(this, "hasLoaded", !1);
    const { promise: n, resolve: i } = Promise.withResolvers();
    this.waitForLoad = n, this.messageListener = (s) => this.messageHandler(s.data), window.addEventListener("message", this.messageListener), this.addAppMessageListener(({ data: s }) => {
      i(), Xt(() => {
        this.hasLoaded = !0, this.playerStore.smartUpdatePlayers(s.players), this.lobbyGame = s.lobbyGame, this.devMode = s.devMode, this.joinCode = s.joinCode, this.joinUrl = s.joinUrl, this.connectionId = s.connectionId, !this.dataPersistence.globalSettings || !s.globalSettings ? this.dataPersistence.globalSettings = s.globalSettings : Ne(this.dataPersistence.globalSettings, s.globalSettings), !this.dataPersistence.gameStorage || !s.gameStorage ? this.dataPersistence.gameStorage = s.gameStorage : Ne(this.dataPersistence.gameStorage, s.gameStorage);
      });
    }, b.AppData_HOSTER), this.sendAppMessage({
      type: b.INIT_GAME_HOSTER,
      data: {
        coreVersion: "0.2.17"
      }
    }), this.setupPingPong(), r && setTimeout(() => {
      this.ready();
    }, 1e3), lr(this, {}, { autoBind: !0 });
  }
  /** Alias to playerStore.players */
  get players() {
    return this.playerStore.players;
  }
  /** Alias to playerStore.playerMap */
  get playerMap() {
    return this.playerStore.playerMap;
  }
  /**
   * Removes the event listener for message events.
   * Use this when you are done with the controller.
   */
  destructor() {
    window.removeEventListener("message", this.messageListener);
  }
  /**
   * Sets the ready status of the controller.
   */
  ready() {
    this.isReady = !0, this.sendAppMessage({
      type: b.READY_STATUS_HOSTER,
      data: {
        ready: !0
      }
    });
  }
  /**
   * Sets the controller to an unready state. Note: this should never have to happen
   */
  unready() {
    this.isReady = !1, this.sendAppMessage({
      type: b.READY_STATUS_HOSTER,
      data: {
        ready: !1
      }
    });
  }
  setupPingPong() {
    setInterval(() => {
      const n = this.players.filter((i) => i.active);
      for (const i of n)
        this.fetchPing(i.connectionId);
    }, 2500);
  }
  async fetchPing(r) {
    const n = Math.random().toString(36).slice(2), i = Date.now();
    this.sendAppMessage({
      type: b.PING_HOSTER,
      data: {
        id: n,
        playerId: r,
        timeSinceStart: i - this.startTime,
        hosterTime: i
      }
    });
    const { promise: s, resolve: o } = Promise.withResolvers(), a = this.addAppMessageListener((p) => {
      p.data.playerId === r && p.data.id === n && o();
    }, b.PONG_CONTROLLER);
    await s, a.destroy();
    const u = Date.now() - i, c = Date.now();
    this.sendAppMessage({
      type: b.PONG_HOSTER,
      data: {
        id: n,
        playerId: r,
        pingMs: u,
        timeSinceStart: c - this.startTime,
        hosterTime: c
      }
    });
    const f = this.playerMap.get(r);
    return f && (Xt(() => {
      this.playerPingMap.set(r, {
        player: f,
        ping: u,
        lastPoll: c
      });
    }), this.playerPingListeners.forEach(({ listener: p }) => {
      p({
        player: f,
        ping: u,
        lastPoll: c
      });
    })), u;
  }
  /**
   * Sends a game message to a specific user.
   * @param data The game data to send.
   * @param userId The ID of the user to send the message to.
   */
  sendGameMessage(r, n) {
    this.sendMessage({
      type: b.GAME_ACTION_HOSTER,
      data: {
        to: n,
        payload: r
      }
    });
  }
  /**
   * Broadcasts a game message to all connected players.
   *
   * @param data The game message data to be sent.
   */
  broadcastGameMessage(r) {
    for (const n of this.players)
      this.sendGameMessage(r, n.connectionId);
  }
  /**
   * Adds a game message listener.
   *
   * @param listener - The callback function to be called when a game message is received.
   * @returns An object with a `destroy` method that can be used to remove the listener.
   */
  addGameMessageListener(r) {
    const n = {
      listener: (i) => {
        i.type === b.GAME_ACTION_RESPONSE_HOSTER && r(i.data);
      }
    };
    return this.gameMessageListeners.push(n), {
      destroy: () => {
        const i = this.gameMessageListeners.indexOf(n);
        i !== -1 && this.gameMessageListeners.splice(i, 1);
      }
    };
  }
  addPlayerPingListener(r) {
    return this.playerPingListeners.push({ listener: r }), {
      destroy: () => {
        const n = this.playerPingListeners.findIndex(
          (i) => i.listener === r
        );
        n !== -1 && this.playerPingListeners.splice(n, 1);
      }
    };
  }
  endGame() {
    this.sendAppMessage({ type: b.END_GAME_HOSTER, data: {} });
  }
  reloadGame() {
    this.sendAppMessage({ type: b.RELOAD_GAME_HOSTER, data: {} });
  }
  /** This should not be used unless you know what you are doing */
  messageHandler(r) {
    if (super.messageHandler(r), r.type === b.GAME_ACTION_RESPONSE_HOSTER) {
      this.gameMessageListeners.forEach((n) => n.listener(r));
      return;
    }
  }
}
export {
  hn as BaseCommunicator,
  b as CommunicationDataType,
  Es as ControllerCommunicator,
  ds as ControllerDataPersistence,
  cn as DAY_AS_MS,
  Ss as DEG_TO_RAD,
  Dt as HOUR_AS_MS,
  ys as HosterCommunicator,
  hs as HosterDataPersistence,
  wt as MINUTE_AS_MS,
  _s as MaturityLevel,
  kt as PlayerModel,
  bs as PlayerStore,
  Ts as RAD_TO_DEG,
  Rt as SECOND_AS_MS,
  ps as SmartPlayerModel,
  cr as Subscription,
  z as Time,
  Ls as Vector2,
  Rs as angleDifference,
  ws as clamp,
  Os as getTimeMilliseconds,
  ms as getTimeSeconds,
  _r as isCommunicationDataTransfer,
  Ds as lerp,
  Ms as lerpAngle,
  hr as messageParent,
  Ps as perlinNoise,
  Vs as random,
  js as randomBool,
  Cs as randomChoice,
  Gs as randomInt,
  xs as randomSign,
  Is as shuffle,
  Bs as shuffleInPlace
};
